{
  "common": {
    "loading": "Chargement…",
    "retry": "Réessayer",
    "cancel": "Annuler",
    "close": "Fermer",
    "back": "Retour",
    "logout": "Se déconnecter",
    "or": "ou",
    "home": "Accueil",
    "poweredBy": "Propulsé par {{product}}",
    "academicYear": "Année universitaire {{year}}",
    "save": "Enregistrer",
    "edit": "Modifier",
    "delete": "Supprimer",
    "all": "Tous",
    "reset": "Réinitialiser",
    "columns": "Colonnes",
    "export": "Exporter",
    "actions": "Actions",
    "saving": "Enregistrement…",
    "saved": "Enregistré",
    "phaseSoon": "Disponible en phase {{phase}}"
  },
  "languages": {
    "fr": "Français",
    "ar": "العربية",
    "en": "English",
    "short": {
      "fr": "FR",
      "ar": "العربية",
      "en": "EN"
    }
  },
  "roles": {
    "SUPER_ADMIN": "Super-admin plateforme",
    "ADMIN_ECOLE": "Administration",
    "AGENT_SCOLARITE": "Agent scolarité",
    "AGENT_FINANCE": "Agent finance",
    "ENSEIGNANT": "Enseignant",
    "ETUDIANT": "Étudiant",
    "CANDIDAT": "Candidat"
  },
  "auth": {
    "heroTitle": "Votre espace scolarité",
    "heroText": "Inscriptions, notes, absences, paiements et documents officiels — au même endroit, pour toute l'équipe et chaque étudiant.",
    "title": "Connexion",
    "subtitle": "Utilisez votre e-mail institutionnel ou votre matricule.",
    "identifier": "E-mail ou matricule",
    "password": "Mot de passe",
    "showPassword": "Afficher le mot de passe",
    "hidePassword": "Masquer le mot de passe",
    "remember": "Rester connecté",
    "forgot": "Mot de passe oublié ?",
    "submit": "Se connecter",
    "submitting": "Connexion…",
    "sso": "Continuer avec l'authentification unique (SSO)",
    "ssoShort": "Connexion SSO",
    "ssoInfo": "L'authentification unique sera disponible dès que votre établissement l'aura configurée.",
    "newCandidate": "Nouveau candidat ?",
    "applyLink": "Déposer une préinscription",
    "footer": "© {{year}} {{institution}}",
    "privacy": "Confidentialité",
    "help": "Aide",
    "forgotSent": "Si un compte correspond à « {{identifier}} », un lien de réinitialisation vient d'être envoyé.",
    "forgotNeedIdentifier": "Saisissez d'abord votre e-mail ou matricule.",
    "errors": {
      "identifierRequired": "Saisissez votre e-mail ou votre matricule.",
      "passwordRequired": "Saisissez votre mot de passe.",
      "invalidCredentials": "E-mail, matricule ou mot de passe incorrect.",
      "locked": "Trop de tentatives : votre compte est verrouillé pendant 15 minutes.",
      "rateLimited": "Trop de tentatives. Réessayez dans une minute.",
      "generic": "Connexion impossible. Vérifiez votre réseau puis réessayez.",
      "passwordTooShort": "Le mot de passe doit comporter au moins {{min}} caractères.",
      "passwordMismatch": "Les mots de passe ne correspondent pas.",
      "passwordUnchanged": "Le nouveau mot de passe doit être différent de l'actuel."
    },
    "reset": {
      "title": "Nouveau mot de passe",
      "subtitle": "Choisissez un mot de passe d'au moins {{min}} caractères.",
      "password": "Nouveau mot de passe",
      "confirm": "Confirmer le mot de passe",
      "submit": "Enregistrer le mot de passe",
      "submitting": "Enregistrement…",
      "done": "Mot de passe modifié. Vous pouvez maintenant vous connecter.",
      "invalid": "Ce lien est invalide ou a expiré. Faites une nouvelle demande depuis la page de connexion.",
      "backToLogin": "Retour à la connexion"
    },
    "identifierPlaceholder": "ex. 24GL0137 ou prenom.nom@…",
    "features": {
      "notes": "Notes, délibérations et relevés LMD",
      "absences": "Appel mobile et suivi des absences",
      "finance": "Échéanciers, paiements et reçus",
      "documents": "Documents officiels vérifiables par QR code"
    },
    "forgotTitle": "Mot de passe oublié",
    "forgotText": "Saisissez votre e-mail ou votre matricule : si un compte correspond, vous recevrez un lien pour choisir un nouveau mot de passe.",
    "forgotSubmit": "Envoyer le lien",
    "platform": {
      "heroTitle": "Console plateforme",
      "heroText": "Créez les établissements, invitez leurs administrateurs et gérez leur accès. Les données des écoles restent dans l'espace de chaque établissement.",
      "features": {
        "schools": "Établissements et adresses dédiées",
        "invites": "Invitation des administrateurs",
        "suspend": "Suspension et réactivation",
        "restricted": "Accès réservé à l'équipe plateforme"
      },
      "subtitle": "Accès réservé à l'équipe plateforme. Connectez-vous avec votre e-mail.",
      "identifier": "E-mail",
      "identifierPlaceholder": "prenom.nom@…"
    }
  },
  "shell": {
    "menu": "Menu",
    "productLine": "{{product}} · {{space}}",
    "search": "Rechercher un étudiant, un CIN, un matricule…",
    "searchShortcut": "Ctrl K",
    "lightTheme": "Thème clair",
    "darkTheme": "Thème sombre",
    "notifications": "Notifications",
    "notificationsCount_one": "{{count}} notification non lue",
    "notificationsCount_other": "{{count}} notifications non lues",
    "noNotifications": "Aucune notification.",
    "markAllRead": "Tout marquer comme lu",
    "language": "Langue",
    "year": "Année universitaire",
    "account": "Compte",
    "skipToContent": "Aller au contenu",
    "space": {
      "scolarite": "Scolarité",
      "finance": "Finance",
      "teaching": "Espace enseignant"
    }
  },
  "yearStatus": {
    "draft": "Brouillon",
    "current": "En cours",
    "closed": "Clôturée",
    "archived": "Archivée"
  },
  "nav": {
    "groups": {
      "pilotage": "Pilotage",
      "admissions": "Admissions",
      "scolarite": "Scolarité",
      "evaluation": "Évaluation",
      "finance": "Finance",
      "administration": "Administration"
    },
    "items": {
      "dashboard": "Tableau de bord",
      "preinscriptions": "Préinscriptions",
      "candidatures": "Candidatures",
      "students": "Étudiants",
      "teachers": "Enseignants",
      "curriculum": "Offre de formation",
      "timetable": "Emploi du temps",
      "absences": "Absences",
      "grades": "Saisie des notes",
      "rollCall": "Faire l'appel",
      "deliberations": "Délibérations",
      "documents": "Relevés & attestations",
      "schedules": "Échéanciers",
      "unpaid": "Impayés",
      "settings": "Paramètres",
      "announcements": "Annonces",
      "audit": "Journal d'audit",
      "calendar": "Calendrier",
      "internships": "Stages & PFE"
    }
  },
  "palette": {
    "label": "Recherche globale",
    "placeholder": "Nom, CIN, matricule ou page…",
    "escape": "Échap",
    "students": "Étudiants",
    "pages": "Pages",
    "noStudent": "Aucun étudiant ne correspond à « {{q}} ».",
    "meta": "{{matricule}} · CIN {{cin}}",
    "level": "{{level}} · Groupe {{group}}"
  },
  "comingSoon": {
    "title": "Module en préparation",
    "text": "Cet écran sera livré en phase {{phase}}. La navigation, les droits d'accès et la recherche sont déjà actifs."
  },
  "dashboard": {
    "greeting": "Bonjour {{name}} — {{date}}.",
    "greetingWeek": "Bonjour {{name}} — activité du {{date}}, semaine {{week}}.",
    "newEnrollment": "Nouvelle inscription",
    "kpi": {
      "students": "Étudiants inscrits",
      "vsPrevious": "vs année précédente",
      "applications": "Candidatures en attente",
      "staleNote": "sans réponse depuis +{{days}} jours",
      "paymentRate": "Taux de paiement",
      "ofDue": "sur {{amount}} échus",
      "absences": "Absences de la semaine",
      "nearCount_one": "{{count}} étudiant",
      "nearCount_other": "{{count}} étudiants",
      "nearNote": "proches du seuil d’élimination"
    },
    "programs": {
      "title": "Inscriptions par filière",
      "subtitle": {
        "all": "Inscrits / capacité de la filière (toutes années) · {{year}}",
        "first": "Inscrits en 1re année / places de recrutement · {{year}}",
        "upper": "Inscrits en 2e année et plus / places restantes · {{year}}"
      },
      "first": "1re année",
      "upper": "2e année +",
      "fill": "Taux de remplissage :",
      "total": "Total inscrits :"
    },
    "todo": {
      "title": "À traiter",
      "count_one": "{{count}} élément",
      "count_other": "{{count}} éléments",
      "juries": {
        "title": "Délibérations à tenir",
        "meta": "Jurys de la session principale non clôturés",
        "action": "Ouvrir"
      },
      "incompleteApplications": {
        "title": "Dossiers de candidature incomplets",
        "meta": "Pièces obligatoires manquantes ou refusées",
        "action": "Voir"
      },
      "staleApplications": {
        "title": "Candidatures sans réponse",
        "meta": "Au-delà du délai annoncé aux candidats",
        "action": "Examiner"
      },
      "pendingCheques": {
        "title": "Chèques à encaisser",
        "meta": "Paiements par chèque en attente",
        "action": "Traiter"
      },
      "timetableConflicts": {
        "title": "Conflits d'emploi du temps",
        "meta": "Salles, enseignants ou groupes en double ce semestre",
        "action": "Résoudre"
      }
    },
    "payments": {
      "title": "Derniers paiements",
      "all": "Voir les encaissements",
      "columns": {
        "student": "Étudiant",
        "matricule": "Matricule",
        "installment": "Échéance",
        "mode": "Mode",
        "amount": "Montant",
        "date": "Date",
        "status": "Statut"
      }
    }
  },
  "errors": {
    "notFoundTitle": "Page introuvable",
    "notFoundText": "L'adresse demandée n'existe pas ou a été déplacée.",
    "forbiddenTitle": "Accès refusé",
    "forbiddenText": "Votre rôle ne donne pas accès à cette page. Contactez l'administration si nécessaire.",
    "tenantNotFoundTitle": "Établissement introuvable",
    "tenantNotFoundText": "Vérifiez l'adresse : chaque établissement dispose de sa propre adresse, par exemple ecole.{{domain}}.",
    "loadFailedTitle": "Impossible de charger les données",
    "loadFailedText": "Vérifiez votre connexion puis réessayez. Si le problème persiste, contactez le support.",
    "goHome": "Retour à l'accueil",
    "actionFailed": "L'opération n'a pas abouti. Réessayez dans un instant."
  },
  "student": {
    "hello": "Bonjour,",
    "offline": "Hors ligne · données du {{date}}",
    "offlineEmpty": "Hors ligne. Connectez-vous une première fois pour consulter vos données sans réseau.",
    "nav": {
      "label": "Navigation principale",
      "home": "Accueil",
      "notes": "Notes",
      "edt": "Emploi",
      "pay": "Paiements",
      "more": "Plus"
    },
    "home": {
      "next": "Prochain cours",
      "now": "maintenant",
      "inMinutes": "dans {{n}} min",
      "todayAt": "aujourd'hui à {{time}}",
      "noNext": "Aucun cours prévu",
      "average": "Moyenne S{{n}}",
      "noAverage": "Pas encore de moyenne",
      "allPaid": "Tout est réglé",
      "absences": "d'absence",
      "absencesToJustify": "d'absence · {{hours}} à justifier",
      "documents_one": "document disponible",
      "documents_other": "documents disponibles",
      "seeAll": "Tout voir",
      "announcementsAria_one": "Annonces, {{count}} non lue",
      "announcementsAria_other": "Annonces, {{count}} non lues",
      "documents_zero": "documents disponibles"
    },
    "more": {
      "abs": "Absences",
      "docs": "Documents",
      "ann": "Annonces",
      "cal": "Calendrier",
      "stages": "Stages"
    },
    "notes": {
      "title": "Mes notes",
      "semesters": "Semestres",
      "semester": "Semestre {{n}}",
      "average": "Moyenne du semestre",
      "provisional": "Provisoire",
      "provisionalHint": "Résultats provisoires : la décision sera publiée après le jury.",
      "credits_one": "{{count}} crédit",
      "credits_other": "{{count}} crédits",
      "coef": "Coef. {{coef}}",
      "compensated": "compensée",
      "emptyTitle": "Pas encore de notes",
      "emptyText": "Vos notes apparaîtront ici dès leur publication.",
      "semesterShort": "S{{n}}"
    },
    "week": {
      "days": "Jours de la semaine",
      "empty": "Aucun cours ce jour."
    },
    "pay": {
      "title": "Paiements",
      "paidOf": "Réglé sur {{total}}",
      "progress": "Part réglée des frais",
      "pending": "{{amount}} en cours d'encaissement",
      "due": "Échéance {{date}}",
      "emptyTitle": "Aucun échéancier",
      "emptyText": "Votre échéancier sera affiché ici dès votre inscription."
    },
    "abs": {
      "summary": "{{hours}} d'absence · {{justified}} justifiées",
      "status": {
        "justified": "Justifiée",
        "pending": "En vérification",
        "unjustified": "Non justifiée"
      },
      "send": "Envoyer un justificatif",
      "sheetTitle": "Envoyer un justificatif",
      "alsoCover": "Couvre aussi",
      "photo": "Prendre une photo du justificatif",
      "photoHint": "Photo, JPG, PNG ou PDF · 5 Mo max",
      "change": "Touchez pour changer de fichier",
      "submit": "Envoyer à la scolarité",
      "sent": "Justificatif envoyé à la scolarité.",
      "failed": "Envoi impossible. Réessayez.",
      "badType": "Format non accepté : JPG, PNG ou PDF.",
      "emptyTitle": "Aucune absence",
      "emptyText": "Vous n'avez aucune absence cette année."
    },
    "docs": {
      "download": "Télécharger {{name}}",
      "empty": "Aucun document disponible pour l'instant.",
      "request": "Demander un document",
      "requestHint": "Attestation de présence, stage…",
      "kind": "Type de document",
      "note": "Précision (facultatif)",
      "notePlaceholder": "Ex. : pour la CNAM, en deux exemplaires",
      "send": "Envoyer la demande",
      "requested": "Demande envoyée à la scolarité.",
      "duplicate": "Une demande de ce type est déjà en cours.",
      "failed": "Envoi impossible. Réessayez.",
      "myRequests": "Mes demandes"
    },
    "requestKinds": {
      "enrollment_certificate": "Attestation d'inscription",
      "attendance_certificate": "Attestation de présence",
      "transcript": "Relevé de notes",
      "internship": "Convention de stage",
      "other": "Autre document"
    },
    "requestStatus": {
      "pending": "En cours",
      "done": "Traitée",
      "rejected": "Refusée"
    },
    "ann": {
      "empty": "Aucune annonce pour le moment."
    },
    "cal": {
      "empty": "Aucune date à venir.",
      "showPast_one": "Afficher {{count}} date passée",
      "showPast_other": "Afficher {{count}} dates passées",
      "hidePast": "Masquer les dates passées"
    },
    "stages": {
      "empty": "Aucun stage cette année.",
      "emptyText": "Déclarez votre stage dès que l'entreprise vous a accepté(e) : la scolarité valide le sujet et la convention apparaît dans vos documents.",
      "declare": "Déclarer un stage",
      "declareHint": "Le sujet est validé par la scolarité. Vous pouvez proposer un encadrant : il recevra une demande.",
      "editTitle": "Modifier mon stage",
      "send": "Envoyer pour validation",
      "askSupervisor": "Proposer un encadrant",
      "askSupervisorHint": "L'enseignant choisi reçoit votre demande et l'accepte ou la refuse.",
      "sendRequest": "Envoyer la demande",
      "convention": "Votre convention de stage est disponible dans Plus › Documents."
    }
  },
  "candidate": {
    "title": "Suivi de votre candidature",
    "comingSoonText": "Le suivi détaillé de votre dossier de préinscription sera disponible ici (phase 4)."
  },
  "platform": {
    "title": "Établissements",
    "subtitle": "Console plateforme · {{count}} établissements",
    "columns": {
      "name": "Établissement",
      "slug": "Adresse",
      "status": "Statut",
      "users": "Comptes",
      "students": "Étudiants",
      "createdAt": "Créé le"
    },
    "status": {
      "active": "Actif",
      "suspended": "Suspendu"
    },
    "create": "Nouvel établissement",
    "suspend": "Suspendre",
    "reactivate": "Réactiver",
    "reinvite": "Renvoyer l’invitation",
    "created": "Établissement créé. L’invitation a été envoyée.",
    "suspended": "Établissement suspendu.",
    "reactivated": "Établissement réactivé.",
    "reinvited": "Invitation renvoyée.",
    "suspendTitle": "Suspendre {{name}} ?",
    "suspendText": "Les utilisateurs de cet établissement ne pourront plus se connecter.",
    "fields": {
      "slug": "Adresse (slug)",
      "name": "Raison sociale",
      "shortName": "Sigle",
      "color": "Couleur principale",
      "firstName": "Prénom de l’administrateur",
      "lastName": "Nom de l’administrateur",
      "email": "E-mail de l’administrateur",
      "yearLabel": "Première année",
      "startsOn": "Rentrée",
      "s1EndsOn": "Fin du semestre 1",
      "s2EndsOn": "Fin du semestre 2",
      "endsOn": "Fin d’année",
      "slugHelp": "Lettres minuscules, chiffres et tirets (3 à 32). Exemple : esprit."
    },
    "errors": {
      "generic": "Opération refusée.",
      "slug": "Adresse invalide : lettres, chiffres et tirets, 3 à 32 caractères.",
      "slugReserved": "Cette adresse est réservée.",
      "required": "Champ obligatoire.",
      "shortName": "12 caractères au plus.",
      "email": "Adresse e-mail invalide."
    },
    "documentTitle": "Console · {{product}}",
    "scope": "Console plateforme",
    "kpi": {
      "schools": "Établissements",
      "active_one": "{{count}} actif",
      "active_other": "{{count}} actifs",
      "suspended": "Suspendus",
      "users": "Comptes",
      "students": "Étudiants"
    },
    "empty": "Aucun établissement. Créez le premier avec « Nouvel établissement ».",
    "sheet": {
      "label": "Fiche établissement",
      "address": "Adresse",
      "createdOn": "Créé le {{date}}",
      "accounts": "Comptes par rôle",
      "noAccounts": "Aucun compte.",
      "admins": "Administrateurs",
      "noAdmin": "Aucun administrateur.",
      "lastLogin": "Dernière connexion le {{date}}",
      "neverLoggedIn": "Jamais connecté",
      "open": "Ouvrir l'espace",
      "studentRecords": "Dossiers étudiants"
    },
    "adminState": {
      "invited": "Invitation en attente",
      "active": "Actif",
      "disabled": "Désactivé"
    },
    "reinviteTitle": "Renvoyer l'invitation ?",
    "reinviteText": "Un nouveau lien sera envoyé à {{email}}. Les liens envoyés précédemment restent valables jusqu'à leur expiration.",
    "nav": {
      "label": "Sections de la console",
      "schools": "Établissements",
      "journal": "Journal"
    },
    "journalSubtitle": "Établissements créés, suspendus, réactivés, invitations renvoyées et changements de mot de passe de la console."
  },
  "public": {
    "applyTitle": "Préinscription en ligne",
    "applyText": "Le formulaire public de préinscription sera disponible ici (phase 4)."
  },
  "enrollmentStatus": {
    "en_cours": "Inscrit",
    "en_cours_F": "Inscrite",
    "admis": "Admis",
    "admis_F": "Admise",
    "ajourne": "Ajourné",
    "ajourne_F": "Ajournée",
    "abandon": "Abandon",
    "abandon_F": "Abandon",
    "none": "Non inscrit",
    "none_F": "Non inscrite",
    "current": "En cours"
  },
  "students": {
    "title": "Étudiants",
    "subtitle": "{{count}} étudiants · année {{year}}",
    "new": "Nouvel étudiant",
    "search": "Nom, CIN ou matricule",
    "filters": {
      "program": "Filière",
      "level": "Niveau",
      "group": "Groupe",
      "status": "Statut",
      "allPrograms": "Toutes les filières",
      "allLevels": "Tous les niveaux",
      "allGroups": "Tous les groupes",
      "allStatuses": "Tous les statuts"
    },
    "columns": {
      "matricule": "Matricule",
      "name": "Nom et prénom",
      "program": "Filière",
      "level": "Niveau",
      "group": "Groupe",
      "status": "Statut"
    },
    "selection_one": "{{count}} étudiant sélectionné",
    "selection_other": "{{count}} étudiants sélectionnés",
    "clearSelection": "Désélectionner",
    "changeGroup": "Changer de groupe",
    "changeGroupHint": "Sélectionnez des étudiants d’un même niveau pour changer leur groupe.",
    "changeGroupTitle": "Changer de groupe · {{count}} étudiant(s)",
    "groupChanged": "{{count}} étudiant(s) déplacé(s) dans le groupe {{group}}.",
    "openRecord": "Ouvrir le dossier",
    "emptyTitle": "Aucun étudiant pour ces filtres",
    "emptyText": "Modifiez les critères ou réinitialisez la recherche pour afficher tous les étudiants.",
    "errors": {
      "required": "Champ obligatoire.",
      "cin": "Le CIN doit comporter 8 chiffres.",
      "email": "Adresse e-mail invalide.",
      "phone": "Numéro de téléphone invalide.",
      "date": "Date invalide (jj/mm/aaaa).",
      "average": "La moyenne doit être comprise entre 0 et 20.",
      "level": "Choisissez un niveau.",
      "duplicateCin": "Un étudiant avec ce CIN existe déjà.",
      "save": "Enregistrement impossible. Vérifiez les champs puis réessayez."
    },
    "import": {
      "open": "Importer",
      "title": "Importer des étudiants · {{year}}",
      "intro": "Une ligne par étudiant. Nom, Prénom et Niveau sont obligatoires ; les autres colonnes du modèle sont facultatives. Un étudiant déjà connu (même matricule ou même CIN) n'est pas modifié : il est seulement inscrit pour l'année.",
      "pick": "Choisir un fichier Excel (.xlsx)",
      "hint": "ou le déposer ici · 2 000 lignes au plus",
      "analysing": "Analyse du fichier…",
      "detected_one": "{{formatted}} ligne lue",
      "detected_other": "{{formatted}} lignes lues",
      "template": "Télécharger le modèle",
      "apply_one": "Importer {{count}} étudiant",
      "apply_other": "Importer {{count}} étudiants",
      "applied": "Import terminé.",
      "toCreate_one": "{{count}} nouvel étudiant sera créé et inscrit",
      "toCreate_other": "{{count}} nouveaux étudiants seront créés et inscrits",
      "created_one": "{{count}} étudiant créé et inscrit",
      "created_other": "{{count}} étudiants créés et inscrits",
      "toEnroll_one": "{{count}} étudiant déjà connu sera inscrit pour l'année",
      "toEnroll_other": "{{count}} étudiants déjà connus seront inscrits pour l'année",
      "enrolled_one": "{{count}} étudiant déjà connu inscrit pour l'année",
      "enrolled_other": "{{count}} étudiants déjà connus inscrits pour l'année",
      "skipped_one": "{{count}} étudiant déjà inscrit cette année : ignoré",
      "skipped_other": "{{count}} étudiants déjà inscrits cette année : ignorés",
      "rejected_one": "{{count}} ligne à corriger : elle ne sera pas importée",
      "rejected_other": "{{count}} lignes à corriger : elles ne seront pas importées",
      "invited_one": "{{count}} e-mail d'accès envoyé",
      "invited_other": "{{count}} e-mails d'accès envoyés",
      "invite": "Envoyer l'accès à l'espace étudiant aux étudiants créés (ceux qui ont un e-mail)",
      "done": "{{created}} créés, {{enrolled}} inscrits",
      "line": "Ligne",
      "problem": "À corriger",
      "errors": {
        "file": "Ce fichier ne peut pas être lu. Enregistrez-le au format Excel (.xlsx) et réessayez.",
        "columns": "Colonnes introuvables : le fichier doit contenir au moins Nom, Prénom et Niveau en première ligne. Partez du modèle.",
        "empty": "Le fichier ne contient aucun étudiant.",
        "too_many": "Plus de 2 000 lignes : découpez le fichier (par filière ou par niveau).",
        "year_closed": "Cette année universitaire est clôturée : choisissez l'année en cours.",
        "size": "Fichier trop volumineux (1 Mo au plus)."
      },
      "rowErrors": {
        "required": "obligatoire",
        "level": "niveau inconnu (voir l'onglet Listes du modèle)",
        "group": "groupe inconnu pour ce niveau et cette année",
        "matricule": "matricule inconnu",
        "duplicate": "en double dans le fichier",
        "cin_taken": "CIN déjà utilisé par un enseignant",
        "duplicate_cin": "CIN déjà utilisé",
        "date": "date invalide (jj/mm/aaaa)",
        "gender": "F ou M",
        "number": "nombre invalide",
        "cin": "8 chiffres",
        "email": "e-mail invalide",
        "phone": "téléphone invalide",
        "average": "moyenne entre 0 et 20",
        "already_enrolled": "déjà inscrit cette année",
        "year_closed": "année clôturée",
        "internal": "erreur inattendue",
        "invalid": "valeur invalide",
        "other_student": "appartient à un autre étudiant ({{ref}}) : vérifiez le nom ou le numéro"
      },
      "homonyms_one": "{{count}} homonyme à vérifier",
      "homonyms_other": "{{count}} homonymes à vérifier",
      "homonymLine": "Ligne {{row}} · {{name}} : même nom que {{ref}}. S'il s'agit de la même personne, indiquez son matricule pour l'inscrire au lieu de créer une nouvelle fiche."
    },
    "access": {
      "action": "Envoyer l'accès",
      "title_one": "Envoyer l'accès à l'espace étudiant",
      "title_other": "Envoyer l'accès à {{count}} étudiants",
      "text": "Chaque étudiant reçoit par e-mail son identifiant (matricule) et un lien pour choisir son mot de passe, valable {{days}} jours. Les étudiants sans adresse e-mail ne reçoivent rien.",
      "confirm": "Envoyer",
      "sent_one": "{{count}} e-mail envoyé",
      "sent_other": "{{count}} e-mails envoyés",
      "withoutEmail_one": "{{count}} étudiant sans e-mail",
      "withoutEmail_other": "{{count}} étudiants sans e-mail"
    }
  },
  "record": {
    "crumb": "Scolarité",
    "tabs": {
      "info": "Informations",
      "enrollments": "Inscriptions",
      "grades": "Notes",
      "absences": "Absences",
      "finance": "Finance",
      "documents": "Documents",
      "history": "Historique"
    },
    "attest": "Attestation d’inscription",
    "releve": "Relevé de notes",
    "statusLine": "{{status}} · {{year}}",
    "groupLine": "{{level}} · Groupe {{group}}",
    "cycle": {
      "ingenieur": "Cycle ingénieur",
      "licence": "Licence",
      "master": "Master"
    },
    "facts": {
      "average": "Moyenne",
      "credits": "Crédits validés (jury)",
      "absences": "Absences {{year}}",
      "balance": "Solde restant",
      "averageSem": "Moyenne S{{n}}"
    },
    "sections": {
      "identity": "Identité",
      "contact": "Contact",
      "bac": "Baccalauréat",
      "guardian": "Tuteur légal"
    },
    "fields": {
      "lastName": "Nom",
      "firstName": "Prénom",
      "lastNameAr": "Nom (arabe)",
      "firstNameAr": "Prénom (arabe)",
      "cin": "CIN",
      "gender": "Genre",
      "birthDate": "Date de naissance",
      "birthPlace": "Lieu de naissance",
      "nationality": "Nationalité",
      "email": "E-mail",
      "phone": "Téléphone",
      "address": "Adresse",
      "city": "Ville",
      "bacSection": "Section",
      "bacSession": "Session",
      "bacYear": "Année",
      "bacAverage": "Moyenne",
      "bacSchool": "Lycée",
      "guardianName": "Nom",
      "guardianRelation": "Lien",
      "guardianPhone": "Téléphone",
      "guardianProfession": "Profession"
    },
    "genders": {
      "F": "Féminin",
      "M": "Masculin"
    },
    "editTitle": "Modifier · {{section}}",
    "saved": "Dossier mis à jour.",
    "enrollmentsHead": {
      "year": "Année",
      "level": "Niveau",
      "group": "Groupe",
      "date": "Inscription le",
      "credits": "Crédits",
      "decision": "Décision"
    },
    "newEnrollment": "Nouvelle inscription",
    "enrollTitle": "Inscription {{year}}",
    "enrolled": "Inscription enregistrée.",
    "changeGroup": "Changer de groupe",
    "groupChanged": "Groupe modifié.",
    "noGroup": "Sans groupe",
    "alreadyEnrolled": "L’étudiant est déjà inscrit pour cette année.",
    "comingTitle": "Bientôt disponible",
    "comingText": "Cet onglet sera alimenté en phase {{phase}}.",
    "historyEmpty": "Aucun événement enregistré.",
    "grades": {
      "empty": "Aucune note pour le moment",
      "semester": "S{{n}} · {{year}}",
      "semAvg": "Moyenne du semestre :",
      "live": "Résultats provisoires calculés à partir des notes saisies (avant délibération).",
      "frozen": "Résultats arrêtés par le jury · {{session}}.",
      "notPublished": "Les résultats seront visibles après la publication du procès-verbal.",
      "head": {
        "unit": "Unité / élément",
        "coef": "Coef.",
        "credits": "Crédits",
        "average": "Moyenne",
        "result": "Résultat"
      },
      "acq": "Acquise",
      "comp": "Compensée",
      "nacq": "Non acquise"
    },
    "notFoundTitle": "Étudiant introuvable",
    "notFoundText": "Ce dossier n'existe pas, a été supprimé, ou n'est pas dans votre périmètre."
  },
  "history": {
    "student_create": "Dossier créé (matricule {{matricule}})",
    "student_update": "Dossier modifié : {{fields}}",
    "enrollment_create": "Inscription en {{level}} validée ({{year}})",
    "enrollment_group_change": "Changement de groupe : groupe {{group}}",
    "enrollment_update": "Inscription mise à jour",
    "unknown": "Événement : {{action}}",
    "meta": "{{date}} · {{actor}}",
    "system": "Système",
    "document_issue": "{{typeLabel}} émis · {{code}}",
    "document_revoke": "Document révoqué : {{reason}}",
    "document_send": "Document envoyé par e-mail à l'étudiant",
    "jury_decision": "Décision du jury modifiée : {{decisionLabel}}",
    "computedDecision": "décision calculée",
    "absence_justify": "Absences justifiées ({{records}} séance(s))",
    "absence_justify_reject": "Justificatif refusé",
    "document_request_done": "Demande traitée : {{kindLabel}}",
    "document_request_rejected": "Demande refusée : {{kindLabel}}",
    "payment_create": "Paiement enregistré : {{amountLabel}} ({{methodLabel}})",
    "payment_cancel": "Paiement annulé : {{amountLabel}}"
  },
  "newStudent": {
    "title": "Nouvel étudiant",
    "subtitle": "Le matricule et le compte de connexion sont créés automatiquement.",
    "enrollment": "Inscription {{year}}",
    "submit": "Créer le dossier",
    "created": "Dossier {{matricule}} créé.",
    "footerHint": "Inscription {{year}} · le matricule est attribué à la création."
  },
  "curriculum": {
    "title": "Offre de formation",
    "listSubtitle": "Parcours LMD par filière · versions et habilitations",
    "new": "Nouveau parcours",
    "columns": {
      "program": "Filière",
      "name": "Parcours",
      "version": "Version",
      "status": "Statut",
      "credits": "Crédits",
      "habilitation": "Habilitation",
      "enrollments": "Inscrits"
    },
    "status": {
      "draft": "Brouillon",
      "published": "Publiée"
    },
    "versionLabel": "v{{version}}",
    "subtitle": "Système LMD · {{semesters}} semestres · {{credits}} crédits ECTS",
    "habilitation": " · habilitation {{from}}-{{to}}",
    "addUnit": "Ajouter une UE au S{{index}}",
    "publish": "Publier l'offre",
    "publishTip": "Corrigez les totaux de crédits pour publier",
    "publishedToast": "Offre de formation publiée — utilisée pour les nouvelles inscriptions.",
    "newVersion": "Créer une nouvelle version",
    "newVersionToast": "Version {{version}} créée en brouillon.",
    "openDraft": "Ouvrir le brouillon",
    "readOnly": "Version publiée, en lecture seule. Créez une nouvelle version pour la modifier.",
    "warnItem": "Semestre {{index}} : {{credits}} crédits sur {{target}}",
    "warnText": "Chaque semestre doit totaliser exactement 30 crédits ECTS avant publication. Ajustez les crédits d'un ECUE ou ajoutez une unité.",
    "okText": "Tous les semestres totalisent 30 crédits. L'offre peut être publiée.",
    "head": {
      "structure": "Structure",
      "nature": "Nature",
      "credits": "Crédits",
      "coef": "Coef.",
      "regime": "Régime"
    },
    "root": "Parcours {{program}} · {{credits}} ECTS",
    "semester": "Semestre {{index}}",
    "choice": "(au choix)",
    "natures": {
      "F": "Fondamentale",
      "T": "Transversale",
      "O": "Optionnelle"
    },
    "regimes": {
      "MIXTE": "Mixte",
      "CC": "Contrôle continu",
      "EXAM": "Examen final"
    },
    "regimeHint": {
      "MIXTE": "Moyenne = {{cc}} % contrôle continu (DS, TP) + {{exam}} % examen final.",
      "CC": "Moyenne calculée uniquement sur les contrôles continus ; pas d’examen final.",
      "EXAM": "Moyenne = examen final uniquement."
    },
    "inspector": {
      "empty": "Sélectionnez une UE ou un ECUE pour modifier ses paramètres.",
      "unitKind": "Unité d’enseignement · {{code}}",
      "courseKind": "ECUE · {{code}}",
      "name": "Intitulé",
      "nameAr": "Intitulé (arabe)",
      "code": "Code",
      "nature": "Nature de l'UE",
      "unitCredits": "Crédits de l'UE (somme des ECUE)",
      "unitCreditsOptional": "Crédits de l'UE (un seul ECUE au choix)",
      "unitHint": "La moyenne de l'UE est la moyenne pondérée de ses ECUE par leurs coefficients.",
      "eliminatory": "Note éliminatoire de l'UE",
      "eliminatoryHint": "Vide : règle de l'établissement.",
      "credits": "Crédits ECTS",
      "coef": "Coefficient",
      "regime": "Régime d'évaluation",
      "hours": "Volume horaire",
      "cm": "Cours",
      "td": "TD",
      "tp": "TP",
      "addCourse": "Ajouter un ECUE",
      "newCourse": "Nouvel ECUE",
      "less": "Moins",
      "more": "Plus"
    },
    "addUnitTitle": "Nouvelle UE · semestre {{index}}",
    "add": "Ajouter",
    "unitAdded": "UE « {{name}} » ajoutée au semestre {{index}}.",
    "deleteTitle": "Supprimer « {{name}} » ?",
    "deleteText": "Les crédits du semestre seront recalculés.",
    "deleted": "Élément supprimé. Crédits recalculés.",
    "newTitle": "Nouveau parcours",
    "program": "Filière",
    "name": "Intitulé du parcours",
    "from": "Habilitation de",
    "to": "à",
    "createDraft": "Créer le brouillon",
    "enrollmentsCount": "{{count}} inscrits",
    "errors": {
      "unitCode": "Code attendu : 2 à 4 lettres puis 1 à 3 chiffres (ex. UEF35).",
      "nameRequired": "Saisissez un intitulé.",
      "duplicate": "Ce code existe déjà dans le parcours.",
      "draftExists": "Un brouillon existe déjà pour cette filière.",
      "published": "Cette version est publiée : créez une nouvelle version pour la modifier.",
      "save": "Modification refusée. Vérifiez la valeur puis réessayez."
    }
  },
  "reference": {
    "errors": {
      "programCode": "Code de 2 à 4 lettres majuscules.",
      "groupName": "Nom de groupe : 1 à 3 caractères (ex. A)."
    }
  },
  "settings": {
    "navLabel": "Sections des paramètres",
    "save": "Enregistrer les modifications",
    "saveStatus": {
      "saving": "Enregistrement…",
      "saved": "Modifications enregistrées",
      "error": "Enregistrement impossible"
    },
    "nav": {
      "etablissement": "Établissement",
      "identite": "Identité visuelle",
      "annees": "Années universitaires",
      "roles": "Rôles & permissions",
      "regles": "Règles de notation",
      "structure": "Structure"
    },
    "errors": {
      "generic": "Modification refusée. Vérifiez les valeurs puis réessayez.",
      "version": "Ces paramètres ont été modifiés entre-temps. Rechargez la page.",
      "defaultLocale": "La langue par défaut doit rester activée.",
      "color": "Couleur invalide.",
      "contrast": "Contraste insuffisant : choisissez une teinte plus foncée (minimum 4,5:1).",
      "thresholds": "Le seuil de surveillance doit rester inférieur ou égal à l’alerte, et l’alerte au seuil d’élimination.",
      "weekdays": "Choisissez au moins un jour.",
      "slots": "Les créneaux ne doivent ni se chevaucher ni se terminer avant de commencer.",
      "eliminatory": "La note éliminatoire doit être inférieure à la moyenne d’admission.",
      "yearDates": "Les dates doivent se suivre : rentrée, fin du S1, fin du S2, fin d’année.",
      "yearLabel": "Libellé attendu : AAAA-AAAA, et unique.",
      "yearOrder": "La nouvelle année doit commencer après la dernière.",
      "yearStatus": "Cette action n’est pas possible pour le statut actuel de l’année.",
      "matriculePattern": "Format de matricule invalide."
    },
    "establishment": {
      "name": "Raison sociale",
      "shortName": "Sigle",
      "agrementNo": "N° d’agrément",
      "address": "Adresse",
      "phone": "Téléphone",
      "email": "E-mail de la scolarité",
      "locales": "Langues de l’interface",
      "localesHint": "Cliquez une langue pour l’activer ou la retirer. « Par défaut » la choisit parmi les langues actives.",
      "default": "par défaut",
      "makeDefault": "Par défaut",
      "saved": "Établissement enregistré."
    },
    "brand": {
      "subtitle": "La couleur principale s’applique immédiatement à toute l’application, aux documents officiels et à l’espace étudiant.",
      "logo": "Logo",
      "replace": "Remplacer",
      "remove": "Retirer",
      "logoHint": "PNG ou JPEG, 1 Mo maximum",
      "logoSaved": "Logo mis à jour.",
      "logoType": "Fichier refusé : PNG ou JPEG uniquement.",
      "logoSize": "Le fichier dépasse 1 Mo.",
      "color": "Couleur principale",
      "custom": "Couleur personnalisée",
      "swatches": {
        "indigo": "Indigo",
        "blue": "Bleu institutionnel",
        "teal": "Bleu-vert",
        "green": "Vert",
        "bordeaux": "Bordeaux",
        "gold": "Or (contraste insuffisant)"
      },
      "contrastOk": "Contraste du texte blanc : {{ratio}}:1 — conforme WCAG AA.",
      "contrastFail": "Contraste du texte blanc : {{ratio}}:1 — insuffisant (minimum 4,5:1). Choisissez une teinte plus foncée.",
      "preview": "Aperçu en direct",
      "dashboard": "Tableau de bord",
      "newEnrollment": "Nouvelle inscription",
      "export": "Exporter",
      "tabInfo": "Informations",
      "tabGrades": "Notes",
      "transcript": "RELEVÉ DE NOTES",
      "letterhead": "En-tête des documents officiels",
      "saved": "Couleur enregistrée."
    },
    "years": {
      "new": "Nouvelle année",
      "empty": "Aucune année universitaire.",
      "rentree": "Rentrée {{date}}",
      "closedOn": "Clôturée le {{date}}",
      "untilS1": "S1 jusqu’au {{date}}",
      "untilS2": "S2 jusqu’au {{date}}",
      "activate": "Ouvrir",
      "archive": "Archiver",
      "delete": "Supprimer",
      "deleteBlocked": "Impossible : des inscriptions existent déjà.",
      "activateTitle": "Ouvrir {{label}} ?",
      "activateText": "Elle devient l’année en cours. L’année en cours actuelle sera clôturée.",
      "archiveTitle": "Archiver {{label}} ?",
      "archiveText": "Une année archivée reste consultable et n’est plus modifiable.",
      "deleteTitle": "Supprimer {{label}} ?",
      "deleteText": "Le brouillon et les copies de groupes, tarifs ou créneaux seront effacés.",
      "activated": "Année ouverte.",
      "archived": "Année archivée.",
      "deleted": "Brouillon supprimé.",
      "created": "Année créée · {{groups}} groupes, {{fees}} tarifs, {{slots}} créneaux.",
      "dialogTitle": "Nouvelle année universitaire",
      "label": "Libellé",
      "startsOn": "Rentrée",
      "s1EndsOn": "Fin du semestre 1",
      "s2EndsOn": "Fin du semestre 2",
      "endsOn": "Fin d’année",
      "copyGroups": "Reprendre les groupes",
      "copyFees": "Reprendre les tarifs",
      "copySlots": "Reprendre les créneaux",
      "helper": "L’offre de formation publiée reste en vigueur : les parcours ne sont pas liés à l’année, ils ne sont pas recopiés. Les groupes et les tarifs peuvent être repris depuis la dernière année (les échéances des tarifs sont décalées d’un an). Les créneaux d’emploi du temps ne sont repris que si vous le demandez.",
      "create": "Créer l’année"
    },
    "roles": {
      "subtitle": "Cliquez sur une case pour accorder ou retirer un accès.",
      "module": "Module",
      "accounts_one": "{{n}} compte",
      "accounts_other": "{{n}} comptes",
      "locked": "Non modifiable",
      "cycle": "Cliquer pour changer",
      "saveFailed": "Droit non modifié.",
      "level": {
        "edit": "Édition",
        "read": "Lecture",
        "own": "Le sien",
        "none": "Aucun"
      },
      "short": {
        "ADMIN_ECOLE": "Administration",
        "AGENT_SCOLARITE": "Scolarité",
        "AGENT_FINANCE": "Finance",
        "ENSEIGNANT": "Enseignant",
        "ETUDIANT": "Étudiant",
        "CANDIDAT": "Candidat"
      },
      "cellLabel": "{{module}} — {{role}} : {{level}}",
      "accounts_zero": "{{n}} comptes"
    },
    "modules": {
      "dashboard": "Tableau de bord",
      "admissions": "Candidatures",
      "students": "Dossiers étudiants",
      "curriculum": "Offre de formation",
      "timetable": "Emploi du temps",
      "attendance": "Absences",
      "grades": "Saisie des notes",
      "deliberations": "Délibérations",
      "documents": "Relevés & attestations",
      "finance": "Finance",
      "announcements": "Annonces",
      "settings": "Paramètres",
      "audit": "Journal d’audit",
      "internships": "Stages & PFE"
    },
    "rules": {
      "title": "Règles de notation & délibération",
      "passMark": "Moyenne d’admission",
      "passMarkHint": "Sur 20, par semestre",
      "eliminatory": "Note éliminatoire d’UE",
      "eliminatoryHint": "Bloque la compensation",
      "weights": "Pondération DS / TP / Examen",
      "weightsHint": "Régime mixte, en %",
      "weightsSum": "Les trois parts doivent totaliser 100 %.",
      "ds": "DS",
      "tp": "TP",
      "exam": "Examen",
      "elimination": "Seuil d’élimination (absences)",
      "eliminationHint": "Absences non justifiées par ECUE. Vide = pas d’élimination.",
      "alert": "Seuil d’alerte (absences)",
      "alertHint": "Notification automatique",
      "watch": "Seuil de surveillance",
      "watchHint": "Doit rester inférieur ou égal au seuil d’alerte",
      "rounding": "Arrondi des moyennes",
      "roundingHint": "À chaque niveau : les moyennes arrondies alimentent le calcul suivant. Au final : précision complète, arrondi seulement à l’affichage.",
      "roundingMode": {
        "each_level": "À chaque niveau",
        "final": "Au final seulement"
      },
      "compensation": "Compensation entre UE du même semestre",
      "compensationHint": "Semestre acquis si moyenne ≥ 10 et aucune UE éliminatoire",
      "retake": "Conserver la meilleure note en rattrapage",
      "retakeHint": "Sinon la note du rattrapage remplace la note initiale",
      "publish": "Publier automatiquement les résultats",
      "publishHint": "Dès la signature du PV par le président du jury",
      "timetableTitle": "Emploi du temps",
      "weekdays": "Jours ouvrés",
      "weekdaysHint": "Au moins un jour",
      "weekday": {
        "1": "Lun",
        "2": "Mar",
        "3": "Mer",
        "4": "Jeu",
        "5": "Ven",
        "6": "Sam",
        "7": "Dim"
      },
      "slots": "Créneaux",
      "slotsHint": "Heures de début et de fin, sans chevauchement",
      "slotStart": "Début",
      "slotEnd": "Fin",
      "addSlot": "Ajouter un créneau",
      "removeSlot": "Retirer le créneau",
      "featuresTitle": "Fonctions à venir",
      "featuresHint": "Ces options restent sans effet tant qu’un prestataire n’est pas branché.",
      "feature": {
        "onlinePayment": "Paiement en ligne",
        "smsReminders": "Rappels SMS",
        "whatsappReminders": "Rappels WhatsApp",
        "sso": "Authentification unique (SSO)"
      },
      "documentsTitle": "Documents et matricules",
      "signatoryName": "Signataire",
      "signatoryTitle": "Qualité du signataire",
      "city": "Ville (« Fait à »)",
      "matricule": "Format du matricule",
      "matriculeHint": "{YY}{PROGRAM}{SEQ:4}",
      "saved": "Règles enregistrées.",
      "eliminationBarsExam": "Élimination pour absences : rattrapage obligatoire",
      "eliminationBarsExamHint": "L’ECUE éliminée n’est pas acquise en session principale et bloque la compensation",
      "reviewDays": "Demandes de vérification de note",
      "reviewDaysHint": "Délai laissé aux étudiants après la publication des résultats d'une session.",
      "reviewDaysValue_one": "{{count}} jour",
      "reviewDaysValue_other": "{{count}} jours",
      "reviewDaysOff": "Désactivées"
    },
    "structure": {
      "programs": "Filières",
      "groups": "Groupes",
      "rooms": "Salles",
      "addProgram": "Nouvelle filière",
      "addGroup": "Nouveau groupe",
      "addRoom": "Nouvelle salle",
      "editRoom": "Modifier la salle",
      "empty": "Aucun élément.",
      "noYear": "Choisissez une année universitaire dans la barre du haut.",
      "code": "Code",
      "name": "Nom",
      "nameAr": "Nom en arabe",
      "cycle": "Cycle",
      "duration": "Durée (années)",
      "years": "{{n}} ans",
      "capacity": "Capacité",
      "seats": "{{size}} / {{capacity}}",
      "level": "Niveau",
      "groupName": "Nom du groupe",
      "kind": "Type",
      "status": "Statut",
      "active": "Active",
      "inactive": "Inactive",
      "create": "Créer",
      "programCreated": "Filière créée.",
      "groupCreated": "Groupe créé.",
      "roomSaved": "Salle enregistrée.",
      "cycles": {
        "ingenieur": "Ingénieur",
        "licence": "Licence",
        "master": "Master"
      },
      "kinds": {
        "amphi": "Amphithéâtre",
        "salle": "Salle",
        "labo": "Laboratoire"
      }
    }
  },
  "grades": {
    "mySheets": "Mes saisies de notes",
    "listSubtitle": "Feuilles de notes · {{year}}",
    "empty": "Aucune feuille de notes",
    "emptyText": "Les feuilles apparaissent ici dès que les sessions d'examen sont ouvertes.",
    "notFound": "Feuille de notes introuvable",
    "groupLabel": "{{level}} · Groupe {{group}}",
    "groupLong": "{{level}} Groupe {{group}}",
    "semester": "Semestre {{n}}",
    "formula": "Moyenne = {{weights}}",
    "session": {
      "principale": "Session principale",
      "rattrapage": "Session de rattrapage"
    },
    "status": {
      "brouillon": "Brouillon",
      "transmis": "Transmis"
    },
    "kinds": {
      "DS": "DS",
      "TP": "TP",
      "EXAM": "Examen",
      "RATTRAPAGE": "Rattrapage"
    },
    "columns": {
      "course": "Élément constitutif",
      "group": "Classe",
      "semester": "Semestre",
      "teacher": "Enseignant",
      "progress": "Saisie",
      "status": "Statut",
      "matricule": "Matricule",
      "name": "Nom et prénom",
      "average": "Moyenne"
    },
    "filters": {
      "level": "Niveau"
    },
    "savedAt": "Enregistré à {{time}}",
    "saveFailed": "Échec de l'enregistrement — nouvel essai à la prochaine saisie",
    "cellLabel": "{{kind}} — {{name}}",
    "absentTip": "Absent — compté 0",
    "issues": {
      "invalid_one": "{{count}} valeur invalide à corriger (surlignée en rouge) · {{empty}} note(s) manquante(s). Le verrouillage est désactivé tant que la grille n'est pas complète.",
      "invalid_other": "{{count}} valeurs invalides à corriger (surlignées en rouge) · {{empty}} note(s) manquante(s). Le verrouillage est désactivé tant que la grille n'est pas complète.",
      "empty_one": "{{count}} note manquante. Complétez la grille ou importez un fichier Excel.",
      "empty_other": "{{count}} notes manquantes. Complétez la grille ou importez un fichier Excel."
    },
    "lock": "Verrouiller et transmettre",
    "lockedLabel": "Verrouillé",
    "lockTip": "Corrigez les valeurs invalides et complétez la grille",
    "lockTitle": "Verrouiller et transmettre ?",
    "lockText_one": "La note de {{count}} étudiant sera transmise au jury de délibération. Vous ne pourrez plus la modifier sans demande de correction auprès de la scolarité.",
    "lockText_other": "Les notes des {{count}} étudiants seront transmises au jury de délibération. Vous ne pourrez plus les modifier sans demande de correction auprès de la scolarité.",
    "lockConfirm": "Verrouiller",
    "lockedToast": "Notes verrouillées et transmises au jury.",
    "lockedBanner": "Notes verrouillées et transmises au service scolarité le {{date}} à {{time}}. Toute correction passe désormais par une demande de modification.",
    "unlock": "Déverrouiller",
    "unlockedToast": "Feuille déverrouillée : l'enseignant peut de nouveau saisir.",
    "errors": {
      "format": "Valeur non numérique",
      "range": "Hors plage (0 à 20)",
      "decimals": "Deux décimales au maximum",
      "absentWithValue": "Une note absente ne peut pas avoir de valeur",
      "reason": "Motif trop court (5 caractères minimum)",
      "lock": "Action impossible, réessayez.",
      "lockIncomplete": "La feuille est incomplète : complétez toutes les notes avant de verrouiller.",
      "unlockPv": "Le PV de cette session a été généré : la feuille ne peut plus être déverrouillée."
    },
    "stats": {
      "title": "Statistiques",
      "average": "Moyenne de la classe",
      "max": "Note la plus haute",
      "min": "Note la plus basse",
      "passRate": "Taux de réussite",
      "histogram": "Répartition des moyennes par tranche de 2 points"
    },
    "shortcuts": {
      "title": "Raccourcis clavier",
      "cell": "Cellule suivante",
      "row": "Ligne suivante",
      "enter": "Entrée",
      "absent": "Absent à l'examen",
      "accepted": "Valeurs acceptées : 0 à 20, deux décimales (virgule ou point)."
    },
    "import": {
      "button": "Importer Excel",
      "title": "Importer depuis Excel",
      "pick": "Choisir un fichier .xlsx",
      "hint": "Glissez-déposez le fichier ou cliquez · colonnes Matricule, DS, TP, Examen",
      "detected_one": "{{count}} ligne détectée",
      "detected_other": "{{count}} lignes détectées",
      "recognized_one": "{{count}} matricule reconnu",
      "recognized_other": "{{count}} matricules reconnus",
      "unknown_one": "{{count}} matricule inconnu : {{list}}",
      "unknown_other": "{{count}} matricules inconnus : {{list}}",
      "invalid_one": "{{count}} valeur invalide ignorée : {{list}}",
      "invalid_other": "{{count}} valeurs invalides ignorées : {{list}}",
      "cell": "ligne {{row}}, {{column}} = « {{value}} »",
      "fillable_one": "{{count}} cellule vide sera complétée",
      "fillable_other": "{{count}} cellules vides seront complétées",
      "noOverwrite_one": "Les notes existantes ne sont pas écrasées ({{count}} ignorée).",
      "noOverwrite_other": "Les notes existantes ne sont pas écrasées ({{count}} ignorées).",
      "template": "Télécharger le modèle",
      "apply": "Importer",
      "done_one": "Import terminé : {{count}} note complétée.",
      "done_other": "Import terminé : {{count}} notes complétées.",
      "errors": {
        "file": "Fichier illisible : utilisez le modèle .xlsx.",
        "columns": "Colonnes attendues : Matricule et au moins DS, TP ou Examen.",
        "size": "Fichier trop volumineux (1 Mo maximum).",
        "locked": "La feuille est verrouillée : l'import n'est plus possible."
      },
      "analysing": "Analyse du fichier…"
    },
    "corrections": {
      "request": "Demander une correction",
      "title": "Demande de correction",
      "text": "La feuille est verrouillée. La modification sera appliquée après validation par la scolarité et tracée dans l'historique.",
      "assessment": "Évaluation",
      "current": "Note actuelle",
      "newValue": "Nouvelle note",
      "reason": "Motif",
      "reasonHint": "Ex. : erreur de report, copie re-corrigée…",
      "send": "Envoyer la demande",
      "sent": "Demande de correction envoyée à la scolarité.",
      "pendingExists": "Une demande est déjà en attente pour cette note.",
      "error": "Action impossible, réessayez.",
      "pendingTitle_one": "{{count}} demande de correction en attente",
      "pendingTitle_other": "{{count}} demandes de correction en attente",
      "approve": "Valider",
      "reject": "Refuser",
      "approved": "Correction validée et appliquée.",
      "rejected": "Correction refusée."
    },
    "eliminated": "Éliminé",
    "eliminatedHint": "Seuil d’absences dépassé : ECUE non acquise en session principale, rattrapage obligatoire",
    "savedOn": "Enregistré le {{date}} à {{time}}"
  },
  "deliberation": {
    "title": "Jury {{level}} · Semestre {{n}}",
    "listSubtitle": "Jurys de délibération · {{year}}",
    "empty": "Aucun jury pour cette année",
    "notFound": "Jury introuvable",
    "sessionLabel": "Session",
    "session": {
      "principale": "Session principale",
      "rattrapage": "Rattrapage"
    },
    "sessionLong": {
      "principale": "Session principale",
      "rattrapage": "Session de rattrapage"
    },
    "ueCount_one": "{{count}} UE",
    "ueCount_other": "{{count}} UE",
    "credits_one": "{{count}} crédit",
    "credits_other": "{{count}} crédits",
    "cr_one": "{{count}} cr.",
    "cr_other": "{{count}} cr.",
    "rulesLine": "Compensation semestrielle si moyenne ≥ {{min}} et aucune UE < {{elim}}",
    "rulesLineNoElim": "Compensation semestrielle si moyenne ≥ {{min}}",
    "rulesNoComp": "Pas de compensation semestrielle",
    "pv": {
      "open": "PV à générer",
      "generated": "PV généré",
      "toValidate": "PV à valider",
      "waitingSheets": "Notes en cours",
      "waitingPrincipale": "Après la session principale"
    },
    "generatePv": "Générer le PV",
    "downloadPv": "Télécharger le PV",
    "pvRendering": "PV en cours de génération…",
    "pvFailed": "Échec de génération du PV",
    "blockedTip": "Toutes les feuilles doivent être verrouillées et tous les résultats complets",
    "pendingSheets_one": "{{count}} feuille de notes non verrouillée",
    "pendingSheets_other": "{{count}} feuilles de notes non verrouillées",
    "kpi": {
      "students": "Étudiants",
      "admitted": "Admis",
      "rattrapage": "Rattrapage",
      "ajournes": "Ajournés",
      "passRate": "Taux de réussite"
    },
    "filters": {
      "admitted": "Admis",
      "rattrapage": "Rattrapage",
      "ajournes": "Ajournés"
    },
    "legend": {
      "compensated": "UE compensée",
      "notAcquired": "UE non acquise"
    },
    "columns": {
      "jury": "Jury",
      "sheets": "Feuilles verrouillées",
      "principale": "Session principale",
      "rattrapage": "Rattrapage",
      "student": "Étudiant",
      "average": "Moyenne",
      "credits": "Crédits",
      "compensation": "Compensation",
      "decision": "Décision"
    },
    "comp": {
      "yes_one": "Oui · {{count}} UE",
      "yes_other": "Oui · {{count}} UE",
      "eliminatory": "Non · note < {{grade}}",
      "average": "Non · moyenne < {{min}}",
      "disabled": "Non applicable"
    },
    "incomplete": "Notes incomplètes",
    "incompleteShort": "Incomplet",
    "noStudents": "Aucun étudiant pour cette session",
    "decision": {
      "ADMIS": "Admis",
      "ADMIS_COMPENSATION": "Admis par compensation",
      "RATTRAPAGE": "Rattrapage",
      "AJOURNE": "Ajourné"
    },
    "studentsCount_one": "{{count}} étudiant",
    "studentsCount_other": "{{count}} étudiants",
    "pvToast": "{{file}} généré et envoyé aux membres du jury pour signature.",
    "pvDialog": {
      "title": "Générer le procès-verbal",
      "stats": "Inclure les statistiques par UE",
      "signatures": "Signature électronique des membres du jury",
      "publish": "Publier les résultats sur l'espace étudiant",
      "members": "Membres du jury",
      "president": "{{name}} (président·e)",
      "freeze": "Les décisions seront figées : plus aucune note ni décision de cette session ne pourra être modifiée.",
      "generate": "Générer",
      "generating": "Génération…"
    },
    "override": {
      "button": "Modifier la décision",
      "title": "Décision du jury",
      "computed": "décision calculée : {{decision}}",
      "decision": "Décision retenue",
      "none": "Décision calculée (aucune modification)",
      "reason": "Motif",
      "reasonHint": "Obligatoire, figure dans le journal d'audit.",
      "saved": "Décision du jury enregistrée.",
      "badge": "Décision modifiée par le jury",
      "tip": "Décision modifiée par le jury : {{reason}}"
    },
    "rattrapage": {
      "waitTitle": "Session principale non délibérée",
      "waitText": "Générez d'abord le PV de la session principale : il fixe la liste des étudiants convoqués au rattrapage.",
      "prepareTitle": "Feuilles de rattrapage à préparer",
      "prepareText_one": "{{count}} étudiant convoqué : créez les feuilles de notes des ECUE à repasser.",
      "prepareText_other": "{{count}} étudiants convoqués : créez les feuilles de notes des ECUE à repasser.",
      "prepare": "Préparer les feuilles",
      "prepared": "{{sheets}} feuille(s) de rattrapage créée(s) pour {{students}} étudiant(s)."
    },
    "errors": {
      "blocked": "Génération impossible : des feuilles ne sont pas verrouillées ou des résultats sont incomplets.",
      "generic": "Action impossible, réessayez.",
      "reason": "Motif trop court (5 caractères minimum)"
    }
  },
  "documents": {
    "listSubtitle": "Relevés de notes, attestations et procès-verbaux émis, vérifiables par QR code",
    "newTranscript": "Nouveau relevé",
    "search": "Nom, matricule ou code",
    "count_one": "{{n}} document",
    "count_other": "{{n}} documents",
    "empty": "Aucun document émis",
    "emptyText": "Les relevés et attestations émis depuis le dossier d'un étudiant apparaissent ici.",
    "emptyFiltered": "Aucun document ne correspond aux filtres",
    "code": "Code de vérification",
    "download": "Télécharger",
    "downloadNamed": "Télécharger {{file}}",
    "downloaded": "{{file}} téléchargé (signé électroniquement).",
    "generating": "Génération…",
    "sent": "Document envoyé par e-mail et publié dans l'espace étudiant.",
    "verifyOnline": "Vérifier en ligne",
    "certificateDone": "Attestation d'inscription {{year}} générée.",
    "recordEmpty": "Aucun document émis pour cet étudiant",
    "recordEmptyText": "Générez une attestation d'inscription ou un relevé de notes depuis l'en-tête du dossier.",
    "types": {
      "RELEVE": "Relevé de notes",
      "ATTESTATION_INSCRIPTION": "Attestation d'inscription",
      "PV": "Procès-verbal de délibération",
      "RECU": "Reçu de paiement",
      "CONVENTION_STAGE": "Convention de stage"
    },
    "status": {
      "pending": "En cours",
      "ready": "Valide",
      "failed": "Échec",
      "revoked": "Révoqué"
    },
    "columns": {
      "type": "Document",
      "student": "Étudiant",
      "issuedOn": "Émis le",
      "status": "Statut"
    },
    "meta": {
      "issued": "Émis le {{date}}",
      "revoked": "Révoqué le {{date}}"
    },
    "pick": {
      "label": "Étudiant (nom ou matricule)",
      "hint": "Saisissez au moins 2 caractères",
      "none": "Aucun étudiant trouvé"
    },
    "revoke": {
      "button": "Révoquer",
      "named": "Révoquer le document {{code}}",
      "title": "Révoquer ce document ?",
      "text": "Le code restera reconnu sur la page de vérification mais affiché comme révoqué. Cette action est définitive et tracée.",
      "reason": "Motif de la révocation",
      "reasonHint": "Obligatoire (5 caractères minimum), figure dans le journal d'audit.",
      "confirm": "Révoquer",
      "done": "Document révoqué."
    },
    "transcript": {
      "title": "Relevé de notes",
      "subtitle": "Aperçu A4 · document officiel signé électroniquement",
      "send": "Envoyer à l'étudiant",
      "send_F": "Envoyer à l'étudiante",
      "send_M": "Envoyer à l'étudiant",
      "print": "Imprimer",
      "download": "Télécharger le PDF",
      "options": "Options",
      "semester": "Semestre",
      "semesterN": "Semestre {{n}}",
      "semesterOption": "Semestre {{n}} · {{level}} · {{year}}",
      "qr": "QR code de vérification",
      "courses": "Afficher les ECUE",
      "notIssued": "Non émis — le code est attribué au premier téléchargement ou envoi.",
      "previewTitle": "Aperçu du relevé de notes",
      "emptyTitle": "Aucun semestre délibéré",
      "emptyText": "Un relevé officiel ne peut être émis qu'après la génération du procès-verbal du jury."
    },
    "errors": {
      "generic": "Action impossible, réessayez.",
      "notDeliberated": "Le jury n'a pas encore délibéré ce semestre.",
      "noEmail": "Aucune adresse e-mail dans le dossier de l'étudiant.",
      "withdrawn": "Inscription abandonnée : aucune attestation possible.",
      "reason": "Motif trop court (5 caractères minimum)"
    },
    "requests": {
      "title_one": "{{count}} demande d'étudiant",
      "title_other": "{{count}} demandes d'étudiants",
      "open": "Ouvrir le dossier",
      "done": "Marquer traitée",
      "reject": "Refuser",
      "doneTitle": "Clore la demande comme traitée ?",
      "rejectTitle": "Refuser la demande ?",
      "answer": "Message à l'étudiant (facultatif)",
      "answerDone": "Ex. : à retirer au guichet de la scolarité.",
      "answerRejected": "Ex. : document non disponible pour votre niveau.",
      "doneToast": "Demande traitée. L'étudiant a été notifié.",
      "rejectedToast": "Demande refusée. L'étudiant a été notifié.",
      "failed": "Action impossible. Rechargez la page."
    }
  },
  "verify": {
    "title": "Vérifier un document",
    "intro": "Saisissez le code figurant sous le QR code d'un relevé, d'une attestation ou d'un diplôme délivré par l'établissement.",
    "code": "Code de vérification",
    "submit": "Vérifier",
    "valid": "Document authentique",
    "validText": "Émis par l'établissement et non révoqué à ce jour.",
    "revoked": "Document révoqué",
    "revokedText": "Ce document a été annulé par l'établissement le {{date}} et n'est plus valable.",
    "notFound": "Aucun document ne correspond",
    "notFoundText": "Vérifiez la saisie du code. Si le problème persiste, contactez le service scolarité au {{phone}}.",
    "notFoundTextNoPhone": "Vérifiez la saisie du code. Si le problème persiste, contactez le service scolarité.",
    "limited": "Trop de vérifications en peu de temps. Réessayez dans une minute.",
    "notice": "Les informations affichées doivent correspondre exactement au document présenté. Pour des raisons de confidentialité, le nom est partiellement masqué.",
    "issuedBy": "{{date}} · signé par {{name}}",
    "fields": {
      "type": "Type",
      "holder": "Titulaire",
      "matricule": "Matricule",
      "program": "Formation",
      "period": "Période",
      "issuedOn": "Émis le",
      "receipt": "N° de reçu",
      "amount": "Montant"
    }
  },
  "admissions": {
    "title": "Préinscription {{year}}",
    "stepOf": "Étape {{n}} sur {{total}} · {{name}}",
    "progress": "Progression du formulaire",
    "draft": "Brouillon",
    "draftError": "Hors ligne — nouvel essai",
    "continue": "Continuer",
    "submit": "Envoyer le dossier",
    "sending": "Envoi…",
    "closedTitle": "Préinscriptions fermées",
    "closedText": "Les préinscriptions en ligne de {{name}} ne sont pas ouvertes actuellement.",
    "steps": {
      "program": "Formation",
      "identity": "Identité",
      "school": "Parcours",
      "pieces": "Pièces",
      "recap": "Récapitulatif",
      "programTitle": "Choisissez votre formation",
      "identityTitle": "Votre identité",
      "schoolTitle": "Parcours scolaire",
      "piecesTitle": "Pièces justificatives"
    },
    "programDesc_one": "{{cycle}} · {{count}} an",
    "programDesc_other": "{{cycle}} · {{count}} ans",
    "programMeta": "Capacité {{capacity}} · {{sections}}",
    "fields": {
      "lastName": "Nom",
      "firstName": "Prénom",
      "cin": "N° CIN",
      "birthDate": "Date de naissance",
      "email": "E-mail",
      "phone": "Téléphone",
      "bacSection": "Section du baccalauréat",
      "bacSession": "Session",
      "bacAverage": "Moyenne /20",
      "highSchool": "Lycée d'origine"
    },
    "bacSession": {
      "principale": "Principale {{year}}",
      "controle": "Contrôle {{year}}"
    },
    "sections": {
      "0": "Mathématiques",
      "1": "Sciences expérimentales",
      "2": "Sciences techniques",
      "3": "Informatique",
      "4": "Économie et gestion",
      "5": "Lettres",
      "6": "Sport"
    },
    "sectionsShort": {
      "0": "Maths",
      "1": "Sc. exp.",
      "2": "Sc. tech.",
      "3": "Info",
      "4": "Éco.",
      "5": "Lettres",
      "6": "Sport"
    },
    "sectionDirect": "La section {{section}} donne accès directement à la formation choisie.",
    "sectionCommission": "La section {{section}} n'est pas prioritaire pour cette formation : votre dossier sera étudié par la commission.",
    "pieces": {
      "hint": "PDF, JPG ou PNG · 5 Mo maximum par fichier. Vous pouvez photographier vos documents.",
      "kinds": {
        "cin": "Copie de la CIN (recto-verso)",
        "bac_transcript": "Relevé de notes du baccalauréat",
        "bac_certificate": "Attestation de réussite",
        "photo": "Photo d’identité",
        "fee_receipt": "Reçu des frais de dossier"
      },
      "none": "Non déposé",
      "uploading": "Envoi en cours…",
      "sent": "Envoyé · {{size}}",
      "verified": "Vérifiée par la scolarité",
      "rejected": "À déposer de nouveau : {{reason}}",
      "tooLargeSize": "Fichier trop lourd ({{size}}) — 5 Mo max.",
      "add": "Ajouter",
      "remove": "Retirer",
      "retry": "Réessayer",
      "replace": "Remplacer",
      "errors": {
        "too_large": "Fichier trop lourd — 5 Mo max.",
        "type": "Format non accepté (PDF, JPG ou PNG).",
        "network": "Connexion interrompue.",
        "other": "Envoi impossible, réessayez."
      },
      "open": "Ouvrir : {{name}}",
      "openFailed": "Impossible d'ouvrir la pièce. Réessayez dans un instant."
    },
    "size": {
      "kb": "{{n}} Ko",
      "mb": "{{n}} Mo"
    },
    "recap": {
      "choice": "Choix",
      "level": "Niveau",
      "firstYear": "1re année · {{year}}",
      "name": "Nom",
      "schoolAndPieces": "Parcours & pièces",
      "bac": "Bac",
      "pieces": "Pièces",
      "piecesCount": "{{n}} / {{total}} déposées"
    },
    "consent": "J'atteste l'exactitude des informations fournies et j'accepte le règlement intérieur de l'établissement.",
    "fee": "Frais de dossier",
    "feeHint": "À régler par virement ou au guichet ; joignez le reçu dans les pièces.",
    "sent": {
      "title": "Dossier envoyé",
      "text": "Un e-mail de confirmation a été envoyé à {{email}}.",
      "tracking": "Numéro de suivi",
      "code": "Code d'accès",
      "keep": "Conservez ces deux éléments : ils permettent de suivre votre dossier.",
      "follow": "Suivre mon dossier"
    },
    "track": {
      "title": "Suivi de votre dossier",
      "intro": "Saisissez votre numéro de suivi et le code d'accès reçu par e-mail.",
      "tracking": "Numéro de suivi",
      "code": "Code d'accès",
      "codeHint": "8 caractères, envoyé avec la confirmation de dépôt.",
      "submit": "Consulter",
      "notFound": "Dossier introuvable",
      "notFoundText": "Vérifiez le numéro de suivi et le code d'accès.",
      "follow": "Suivi de votre dossier",
      "filed": "Dossier déposé",
      "feePaid": "Frais de dossier réglés",
      "feeCheck": "Frais de dossier",
      "feeCheckText": "Reçu en cours de vérification",
      "review": "Examen par la commission",
      "reviewText_one": "Réponse sous {{count}} jour ouvré",
      "reviewText_other": "Réponse sous {{count}} jours ouvrés",
      "interview": "Entretien d'admission",
      "decision": "Décision & inscription",
      "decisionText": "Vous serez notifié(e) par e-mail",
      "accepted": "Candidature acceptée",
      "acceptedText": "Le service scolarité vous contactera pour l'inscription.",
      "refused": "Candidature non retenue",
      "refusedText": "Vous pouvez contacter le service scolarité.",
      "missing_one": "{{count}} pièce à déposer ou à remplacer.",
      "missing_other": "{{count}} pièces à déposer ou à remplacer.",
      "trackingFormat": "Format attendu : PRE-2026-0412.",
      "codeFormat": "Le code d'accès compte 8 caractères.",
      "showCode": "Afficher le code",
      "hideCode": "Masquer le code"
    },
    "candidate": {
      "empty": "Aucun dossier de préinscription",
      "emptyText": "Déposez votre candidature en ligne en quelques minutes.",
      "apply": "Commencer ma préinscription",
      "uploadHint": "Pour déposer une pièce, utilisez le suivi avec votre numéro et votre code d'accès."
    },
    "status": {
      "draft": "Brouillon",
      "submitted": "Nouvelle",
      "review": "En étude",
      "interview": "Entretien",
      "accepted": "Acceptée",
      "refused": "Refusée"
    },
    "tabs": {
      "all": "Toutes",
      "submitted": "Nouvelles",
      "review": "En étude",
      "interview": "Entretien",
      "accepted": "Acceptées",
      "refused": "Refusées"
    },
    "columns": {
      "tracking": "N° dossier",
      "candidate": "Candidat",
      "program": "Formation demandée",
      "bac": "Bac · moyenne",
      "filedOn": "Déposée le",
      "pieces": "Pièces",
      "status": "Statut"
    },
    "staff": {
      "title": "Candidatures {{year}}",
      "subtitle": "Examinez les dossiers déposés en ligne et décidez de l'admission.",
      "publicForm": "Voir le formulaire public",
      "search": "Nom, CIN ou n° de dossier",
      "allPrograms": "Toutes les formations",
      "since": "Déposée depuis",
      "selection_one": "{{count}} candidature sélectionnée",
      "selection_other": "{{count}} candidatures sélectionnées",
      "empty": "Aucune candidature pour ces filtres",
      "emptyText": "Modifiez les critères ou réinitialisez la recherche pour afficher toutes les candidatures.",
      "resetFilters": "Réinitialiser les filtres",
      "noneYet": "Aucune candidature reçue",
      "noneYetText": "Les dossiers déposés depuis le formulaire public de préinscription apparaîtront ici."
    },
    "actions": {
      "accept": "Accepter",
      "interview": "Convoquer à un entretien",
      "convoke": "Convoquer",
      "refuse": "Refuser",
      "reopen": "Rouvrir le dossier"
    },
    "bulk": {
      "title": {
        "accept_one": "Accepter cette candidature ?",
        "accept_other": "Accepter {{count}} candidatures ?",
        "interview_one": "Convoquer à un entretien",
        "interview_other": "Convoquer {{count}} candidats à un entretien",
        "refuse_one": "Refuser cette candidature ?",
        "refuse_other": "Refuser {{count}} candidatures ?",
        "review_one": "Rouvrir ce dossier ?",
        "review_other": "Rouvrir {{count}} dossiers ?"
      },
      "text": {
        "accept": "Les candidats seront notifiés par e-mail. Vous pourrez ensuite créer leur dossier étudiant.",
        "interview": "Une convocation est envoyée par e-mail avec la date et l'heure.",
        "refuse": "Les candidats seront notifiés par e-mail. Vous pourrez rouvrir un dossier depuis son historique.",
        "review": "Le dossier repasse « En étude » ; le candidat n'est pas notifié."
      },
      "confirm": {
        "accept": "Accepter",
        "interview": "Envoyer la convocation",
        "refuse": "Refuser",
        "review": "Rouvrir"
      },
      "done": {
        "accept_one": "{{count}} candidature acceptée — e-mail d’admission envoyé.",
        "accept_other": "{{count}} candidatures acceptées — e-mails d’admission envoyés.",
        "interview_one": "{{count}} convocation envoyée pour le {{date}}.",
        "interview_other": "{{count}} convocations envoyées pour le {{date}}.",
        "refuse_one": "{{count}} candidature refusée.",
        "refuse_other": "{{count}} candidatures refusées.",
        "review_one": "{{count}} dossier rouvert.",
        "review_other": "{{count}} dossiers rouverts."
      },
      "skipped_one": "{{count}} dossier ignoré (statut incompatible).",
      "skipped_other": "{{count}} dossiers ignorés (statut incompatible).",
      "reason": "Motif communiqué au candidat (facultatif)",
      "reasonPlaceholder": "Ex. : capacité d'accueil atteinte pour cette formation.",
      "when": "Date et heure de l'entretien"
    },
    "sheet": {
      "label": "Détail de la candidature",
      "program": "Formation demandée",
      "firstYear": "1re année · rentrée {{year}}",
      "interviewOn": "Entretien le {{date}} à {{time}}",
      "refusedReason": "Motif : {{reason}}",
      "bac": "Baccalauréat",
      "bacAverage": "Moyenne au bac",
      "pieceMeta": "{{size}} · déposée le {{date}}",
      "preview": "Aperçu",
      "previewNamed": "Aperçu : {{piece}}",
      "verify": "Valider la pièce",
      "verifyNamed": "Valider : {{piece}}",
      "reject": "Rejeter",
      "rejectNamed": "Rejeter : {{piece}}",
      "rejectTitle": "Rejeter « {{piece}} » ?",
      "rejectText": "Le candidat est prévenu par e-mail et peut déposer une nouvelle pièce depuis son suivi.",
      "rejectReason": "Motif (envoyé au candidat)",
      "rejectPlaceholder": "Ex. : document illisible, recto-verso manquant.",
      "pieceVerified": "Pièce validée.",
      "pieceRejected": "Pièce rejetée — le candidat a été prévenu.",
      "history": "Historique",
      "convert": "Créer le dossier étudiant",
      "converted": "Dossier étudiant créé (matricule {{matricule}}).",
      "openRecord": "Ouvrir le dossier étudiant"
    },
    "pieceStatus": {
      "missing": "Manquante",
      "uploaded": "À vérifier",
      "verified": "Vérifiée",
      "rejected": "Rejetée"
    },
    "mentions": {
      "tres_bien": "Très bien",
      "bien": "Bien",
      "assez_bien": "Assez bien",
      "passable": "Passable"
    },
    "history": {
      "submit": "Dossier déposé en ligne",
      "status": "Statut : {{status}}",
      "piece_verify": "Pièce validée : {{piece}}",
      "piece_reject": "Pièce rejetée : {{piece}} — {{reason}}",
      "piece_upload": "Pièce déposée de nouveau : {{piece}}",
      "convert": "Dossier étudiant créé ({{matricule}})"
    },
    "overview": {
      "title": "Préinscriptions {{year}}",
      "subtitle": "Campagne de préinscription en ligne : lien public, dossiers et capacité d'accueil.",
      "open": "Ouverte",
      "closed": "Fermée",
      "copy": "Copier le lien public",
      "copied": "Lien copié.",
      "filed": "Dossiers déposés",
      "toReview": "À examiner",
      "drafts": "Brouillons en cours",
      "draftsNote": "Formulaires commencés, non envoyés",
      "intake": "Capacité d'accueil par formation",
      "intakeOf": "Admis en {{name}}",
      "intakeLine": "{{accepted}} admis / {{capacity}} places · {{filed}} dossiers",
      "publicLink": "Lien du formulaire public"
    },
    "errors": {
      "required": "Champ obligatoire.",
      "cin": "Le CIN doit comporter 8 chiffres.",
      "email": "Adresse e-mail invalide.",
      "phone": "Numéro de téléphone invalide.",
      "birthDate": "Date de naissance obligatoire.",
      "average": "Moyenne entre 0 et 20.",
      "program": "Choisissez une formation.",
      "tracking": "Numéro de suivi invalide (ex. PRE-2026-0412).",
      "interviewAt": "Indiquez la date de l'entretien.",
      "reason": "Motif trop court.",
      "consent": "Cochez la case pour confirmer.",
      "missingPieces": "Déposez toutes les pièces demandées.",
      "duplicate": "Un dossier existe déjà pour ce CIN cette année.",
      "submit": "Envoi impossible, réessayez.",
      "action": "Action impossible, réessayez."
    },
    "listSeparator": ", "
  },
  "finance": {
    "title": "Frais de scolarité",
    "subtitle_one": "{{year}} · Frais de scolarité : {{total}} – {{count}} tranche",
    "subtitle_other": "{{year}} · Frais de scolarité : {{total}} – {{count}} tranches",
    "tabs": {
      "schedules": "Échéanciers",
      "unpaid": "Impayés",
      "schedulesLong": "Échéancier étudiant",
      "unpaidLong": "Impayés & relances"
    },
    "pickStudent": "Rechercher un étudiant (nom, matricule, CIN)",
    "guardian": "tuteur : {{name}}, {{phone}}",
    "openRecord": "Voir le dossier",
    "otherStudent": "Autre étudiant",
    "chequeNo": "n° {{n}}",
    "status": {
      "paid": "Payé",
      "late": "Impayé",
      "todo": "À venir",
      "pending": "Chèque en attente"
    },
    "paymentStatus": {
      "cleared": "Encaissé",
      "pending": "Chèque en attente",
      "rejected": "Chèque rejeté",
      "cancelled": "Annulé"
    },
    "methods": {
      "cash": "Espèces",
      "cheque": "Chèque",
      "transfer": "Virement",
      "online": "En ligne"
    },
    "channels": {
      "email": "E-mail",
      "sms": "SMS",
      "whatsapp": "WhatsApp"
    },
    "account": {
      "total": "Total {{year}}",
      "paid": "Payé",
      "remaining": "Reste à payer",
      "schedule": "Échéancier",
      "paidPct": "{{pct}} % réglé",
      "columns": {
        "installment": "Échéance",
        "dueOn": "Date limite",
        "amount": "Montant",
        "status": "Statut",
        "detail": "Détail",
        "actions": "Actions"
      },
      "lateBy_one": "En retard de {{count}} jour",
      "lateBy_other": "En retard de {{count}} jours",
      "partial": "{{paid}} réglé",
      "pendingInfo": "{{mode}} · en cours d’encaissement",
      "noInstallments": "Aucun échéancier pour cette année",
      "notEnrolled": "Pas d’inscription pour cette année",
      "canGenerateText": "Le barème de l’année n’a pas encore été appliqué à cette inscription.",
      "noScheduleText": "Aucun barème n’est défini pour cette formation et cette année.",
      "generate": "Générer l’échéancier"
    },
    "actions": {
      "collect": "Encaisser",
      "collectOf": "Encaisser · {{label}}",
      "receipt": "Reçu",
      "cancel": "Annuler le paiement",
      "cancelOf": "Annuler le paiement de la {{label}}",
      "clear": "Chèque encaissé",
      "reject": "Rejeté"
    },
    "pay": {
      "title": "Encaisser · {{label}}",
      "due": "reste dû {{due}}",
      "amount": "Montant (DT)",
      "mode": "Mode de paiement",
      "invalidAmount": "Saisissez un montant valide.",
      "overDue": "Le montant dépasse le reste dû ({{due}}).",
      "chequeNumber": "N° du chèque",
      "bank": "Banque",
      "reference": "Référence",
      "valueDate": "Date de valeur",
      "cashBy": "Reçu par {{name}} · caisse principale · {{date}}",
      "chequeHint": "Le chèque reste « en attente » jusqu’à son encaissement ; le reçu est émis à ce moment-là.",
      "submit": "Enregistrer le paiement"
    },
    "receipt": {
      "title": "Paiement enregistré",
      "number": "Reçu",
      "student": "Étudiant",
      "installment": "Échéance",
      "mode": "Mode",
      "date": "Date",
      "amount": "Montant",
      "print": "Imprimer",
      "send": "Envoyer par e-mail"
    },
    "cancel": {
      "title": "Annuler ce paiement ?",
      "text": "Le paiement de {{amount}} ({{label}}) sera annulé et son reçu révoqué ; la tranche repassera en « Impayé » si elle est échue. Cette action est tracée dans l’historique.",
      "confirm": "Annuler le paiement",
      "keep": "Conserver"
    },
    "toast": {
      "cleared": "{{label}} : chèque encaissé.",
      "rejected": "{{label}} : chèque rejeté — tranche repassée en impayé.",
      "cancelled": "Paiement de la {{label}} annulé.",
      "chequePending": "Chèque enregistré pour la {{label}} — en attente d’encaissement.",
      "receiptSent": "Reçu envoyé par e-mail."
    },
    "errors": {
      "generic": "L’opération a échoué. Réessayez.",
      "receipt": "Le reçu n’a pas pu être généré. Réessayez.",
      "noEmail": "L’étudiant n’a pas d’adresse e-mail.",
      "trancheOrder": "Les dates limites doivent être dans l’ordre des tranches.",
      "chequeNumber": "Indiquez le numéro du chèque.",
      "bank": "Choisissez la banque.",
      "reference": "Indiquez la référence du virement."
    },
    "journal": {
      "title": "Derniers encaissements",
      "pendingCheques": "Chèques en attente",
      "date": "Date",
      "student": "Étudiant",
      "installment": "Échéance",
      "mode": "Mode",
      "amount": "Montant",
      "status": "Statut",
      "receipt": "Reçu",
      "empty": "Aucun paiement",
      "emptyText": "Les encaissements de l’année apparaîtront ici."
    },
    "schedule": {
      "open": "Barème",
      "title": "Barème des frais · {{year}}",
      "text": "Tranches appliquées aux nouvelles inscriptions de l’année. Les échéanciers déjà créés ne sont pas modifiés.",
      "label": "Libellé",
      "note": "Précision",
      "dueOn": "Date limite",
      "amount": "Montant (DT)",
      "add": "Ajouter une tranche",
      "remove": "Supprimer la tranche {{label}}",
      "total": "Total :",
      "trancheN": "Tranche {{n}}",
      "saved": "Barème enregistré.",
      "missing_one": "{{count}} inscription n’a pas encore d’échéancier.",
      "missing_other": "{{count}} inscriptions n’ont pas encore d’échéancier.",
      "apply": "Appliquer le barème",
      "applied_one": "{{count}} échéancier créé.",
      "applied_other": "{{count}} échéanciers créés."
    },
    "unpaid": {
      "kpi": {
        "amount": "Montant impayé",
        "students": "Étudiants concernés",
        "avgLate": "Retard moyen",
        "recovered": "Recouvré ce mois"
      },
      "columns": {
        "student": "Étudiant",
        "program": "Filière",
        "installment": "Échéance",
        "amount": "Montant",
        "late": "Retard",
        "lastReminder": "Dernière relance",
        "status": "Statut"
      },
      "days": "{{n}} j",
      "minDays": "Plus de {{n}} j",
      "reminded": "Relancé",
      "search": "Rechercher un étudiant ou un matricule",
      "selected_one": "{{count}} sélectionné",
      "selected_other": "{{count}} sélectionnés",
      "remind": "Envoyer un rappel",
      "empty": "Aucun impayé",
      "emptyText": "Toutes les échéances passées sont réglées.",
      "emptyFiltered": "Aucun résultat",
      "emptyFilteredText": "Aucun impayé ne correspond à ces filtres.",
      "shown_one": "{{count}} impayé affiché sur {{total}}",
      "shown_other": "{{count}} impayés affichés sur {{total}}"
    },
    "remind": {
      "title_one": "Envoyer un rappel · {{count}} destinataire",
      "title_other": "Envoyer un rappel · {{count}} destinataires",
      "channels": "Canaux",
      "preview": "Aperçu pour {{name}}",
      "body": "Bonjour {{name}}, nous vous rappelons que la {{installment}} des frais de scolarité (reste dû : {{amount}}) était due le {{dueOn}}. Merci de régulariser votre situation auprès du service financier. — {{institution}}",
      "note": "Message complémentaire (facultatif)",
      "noteHint": "Ajouté au rappel de chaque étudiant.",
      "noEmail_one": "{{count}} étudiant n’a pas d’e-mail : il ne recevra pas ce rappel.",
      "noEmail_other": "{{count}} étudiants n’ont pas d’e-mail : ils ne recevront pas ce rappel.",
      "send": "Envoyer",
      "sent_one": "{{count}} rappel envoyé.",
      "sent_other": "{{count}} rappels envoyés.",
      "sentSkipped_one": "{{count}} rappel envoyé ({{skipped}} sans e-mail).",
      "sentSkipped_other": "{{count}} rappels envoyés ({{skipped}} sans e-mail)."
    }
  },
  "attendance": {
    "title": "Suivi des absences",
    "subtitle": "Seuil d’élimination : {{pct}} d’absences non justifiées sur le volume horaire d’un ECUE.",
    "subtitleNoElim": "Pas d’élimination ; alerte à {{alert}} d’absences non justifiées sur le volume horaire d’un ECUE.",
    "rollCallLink": "Appel enseignant (mobile)",
    "notifyAll": "Notifier les étudiants en alerte",
    "listTitle": "Étudiants proches du seuil",
    "thresholdMark": "Seuil {{pct}}",
    "kpi": {
      "hours": "Heures d’absence (semaine {{week}})",
      "justified": "dont {{hours}} justifiées",
      "rate": "Taux d’absentéisme",
      "delta": "{{delta}} pt vs semaine {{week}}",
      "noPrevious": "pas de séance la semaine précédente",
      "alert": "En alerte (≥ {{pct}})",
      "alertNote": "notification recommandée",
      "elim": "Éliminés (≥ {{pct}})",
      "elimNote": "exclus de l’examen de l’ECUE"
    },
    "filters": {
      "all": "Tous",
      "elim": "Éliminés",
      "alert": "Alerte",
      "watch": "Surveillés"
    },
    "levels": {
      "elim": "Éliminé",
      "alert": "Alerte",
      "watch": "Surveillé"
    },
    "columns": {
      "student": "Étudiant",
      "group": "Groupe",
      "course": "ECUE",
      "rate": "Absences non justifiées / seuil",
      "hours": "Heures",
      "status": "Statut"
    },
    "actions": {
      "justify": "Justifier",
      "notify": "Notifier",
      "notified": "Notifié"
    },
    "empty": "Aucun étudiant dans cette catégorie",
    "emptyText": "Les taux d’absences restent sous les seuils.",
    "kinds": {
      "CM": "Cours",
      "TD": "TD",
      "TP": "TP"
    },
    "reasons": {
      "medical": "Certificat médical",
      "administrative": "Convocation administrative",
      "bereavement": "Décès d’un proche",
      "other": "Autre (préciser)"
    },
    "justify": {
      "title": "Justifier une absence",
      "sessions": "Absences couvertes",
      "none": "Aucune absence non justifiée pour cet ECUE.",
      "reason": "Motif",
      "note": "Précision",
      "file": "Joindre le justificatif",
      "fileHint": "PDF, JPG ou PNG · 5 Mo max · facultatif",
      "tooLarge": "Le fichier dépasse 5 Mo.",
      "submit": "Valider le justificatif",
      "done": "Justificatif validé : {{hours}} retirées pour {{name}}."
    },
    "toast": {
      "notifiedOne": "{{name}} notifié(e) par e-mail.",
      "notified_one": "{{count}} étudiant notifié.",
      "notified_other": "{{count}} étudiants notifiés."
    },
    "errors": {
      "generic": "L’opération a échoué. Réessayez.",
      "endBeforeStart": "La fin doit suivre le début.",
      "tooLong": "Une séance dure au plus 6 h."
    },
    "record": {
      "absent": "Heures d’absence",
      "justified": "dont justifiées",
      "late": "Retards",
      "byCourse": "Par ECUE",
      "sessions": "Séances manquées",
      "justifications": "Justificatifs",
      "columns": {
        "course": "ECUE",
        "hours": "Non justifiées / volume",
        "rate": "Taux",
        "status": "Statut"
      },
      "absentMark": "Absent · {{hours}}",
      "justifiedMark": "Justifié · {{hours}}",
      "empty": "Aucune absence",
      "emptyText": "Aucune absence ni retard en {{year}}."
    },
    "pending": {
      "title_one": "{{count}} justificatif à vérifier",
      "title_other": "{{count}} justificatifs à vérifier",
      "meta": "{{hours}} · envoyé le {{date}}",
      "view": "Voir le justificatif",
      "approve": "Valider",
      "reject": "Refuser",
      "rejectTitle": "Refuser le justificatif de {{name}} ?",
      "reason": "Motif communiqué à l'étudiant (facultatif)",
      "approved": "Justificatif validé. L'étudiant a été notifié.",
      "rejected": "Justificatif refusé. L'étudiant a été notifié.",
      "failed": "Action impossible. Rechargez la page."
    }
  },
  "rollCall": {
    "homeTitle": "Faire l’appel",
    "homeSubtitle": "Vos séances du jour et celles dont l’appel reste à faire.",
    "today": "Aujourd’hui",
    "noToday": "Aucune séance aujourd’hui",
    "pending": "Appel à faire",
    "pendingHint": "Séances passées sans appel enregistré.",
    "recent": "Derniers appels",
    "groupLine": "{{level}} Groupe {{group}}",
    "doneChip": "Fait · {{present}}/{{total}}",
    "todoChip": "À faire",
    "newSession": "Séance supplémentaire",
    "newSessionHint": "Pour une séance hors emploi du temps (rattrapage, séance déplacée).",
    "course": "ECUE et groupe",
    "kind": "Type",
    "date": "Date",
    "start": "Début",
    "duration": "Durée",
    "minutes": "{{n}} min",
    "room": "Salle",
    "open": "Ouvrir l’appel",
    "title": "Appel · {{level}} Groupe {{group}}",
    "counters": {
      "present": "Présents",
      "absent": "Absents",
      "late": "Retards"
    },
    "marks": {
      "present": "Présent",
      "absent": "Absent",
      "late": "Retard"
    },
    "tapHint": "Touchez un étudiant pour changer son statut",
    "allPresent": "Tous présents",
    "rowLabel": "{{name}} : {{mark}}. Toucher pour changer.",
    "validate_one": "Valider l’appel · {{count}} étudiant",
    "validate_other": "Valider l’appel · {{count}} étudiants",
    "confirmTitle": "Valider l’appel ?",
    "confirmText": "Les étudiants absents recevront une notification ; ils ont {{hours}} h pour déposer un justificatif.",
    "confirm": "Confirmer",
    "backToRoster": "Revenir à la liste",
    "summary": "{{present}}, {{absent}}, {{late}}.",
    "presentN_one": "{{count}} présent",
    "presentN_other": "{{count}} présents",
    "absentN_one": "{{count}} absent",
    "absentN_other": "{{count}} absents",
    "lateN_one": "{{count}} retard",
    "lateN_other": "{{count}} retards",
    "saved": "Appel enregistré",
    "savedAt": "Enregistré le {{date}} à {{time}}.",
    "edit": "Modifier l’appel",
    "backToList": "Mes séances",
    "alreadyDone": "Appel enregistré le {{date}} à {{time}} — vous pouvez le corriger.",
    "closed": "Cet appel ne peut plus être modifié.",
    "offline": "Hors connexion : l’appel est gardé sur ce téléphone et sera envoyé automatiquement.",
    "retrying": "Envoi impossible pour le moment : l’appel est gardé sur ce téléphone et sera renvoyé automatiquement.",
    "notFound": "Cette séance n’existe pas ou ne vous est pas attribuée.",
    "teacherAbsent": "Enseignant absent : la séance n'a pas eu lieu, il n'y a pas d'appel."
  },
  "timetable": {
    "title": "Emploi du temps",
    "subtitle": "Semestre {{n}} · {{year}}",
    "print": "Imprimer",
    "newSession": "Nouvelle séance",
    "view": "Affichage",
    "modes": {
      "group": "Groupe",
      "teacher": "Enseignant",
      "room": "Salle",
      "overview": "Vue d'ensemble"
    },
    "notPlanned": "non publié",
    "prevWeek": "Semaine précédente",
    "nextWeek": "Semaine suivante",
    "today": "Aujourd'hui",
    "weekLabel": "Semaine {{week}} · {{from}} – {{to}}",
    "days": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Jeu",
      "fri": "Ven",
      "sat": "Sam",
      "sun": "Dim"
    },
    "kinds": {
      "CM": "Cours",
      "TD": "TD",
      "TP": "TP"
    },
    "roomKinds": {
      "amphi": "Amphi",
      "salle": "Salle",
      "labo": "Labo"
    },
    "emptyTitle": "Emploi du temps non publié",
    "emptyText": "Aucune séance n'est prévue cette semaine.",
    "emptyStaff": "Aucune séance cette semaine. Ajoutez-en avec « Nouvelle séance ».",
    "conflicts": "Conflits",
    "noConflict": "Aucun conflit détecté.",
    "conflictTitle": {
      "room": "Salle {{resource}} — {{day}} {{time}}",
      "teacher": "{{resource}} — {{day}} {{time}}",
      "group": "Groupe {{resource}} — {{day}} {{time}}"
    },
    "conflictDetail": "{{a}} et {{b}} se chevauchent.",
    "conflict": {
      "room": "Salle {{resource}} déjà occupée par {{group}} ({{course}})",
      "teacher": "{{resource}} enseigne déjà à {{group}} ({{course}})",
      "group": "Le groupe {{resource}} a déjà {{course}}"
    },
    "freeRoom": "Salle libre suggérée :",
    "reassign": "Réaffecter",
    "reassigned": "{{label}} réaffecté en {{room}}. Étudiants et enseignant notifiés.",
    "selected": "Séance sélectionnée",
    "selectHint": "Sélectionnez une séance dans la grille pour voir le détail.",
    "inConflict": "en conflit",
    "rollCall": "Faire l'appel",
    "openRollCall": "Voir l'appel",
    "slot": {
      "newTitle": "Nouvelle séance",
      "editTitle": "Modifier la séance",
      "group": "Groupe",
      "course": "Matière (ECUE)",
      "teacher": "Enseignant",
      "room": "Salle",
      "day": "Jour",
      "time": "Créneau",
      "kind": "Type",
      "conflictsTitle_one": "{{count}} conflit détecté",
      "conflictsTitle_other": "{{count}} conflits détectés",
      "saveAnyway": "Enregistrer quand même",
      "created": "Séance ajoutée à l'emploi du temps.",
      "updated": "Séance modifiée. Les prochaines séances ont été mises à jour.",
      "deleted": "Séance supprimée.",
      "deleteTitle": "Supprimer cette séance récurrente ?",
      "deleteText": "Toutes les séances de ce créneau sans appel (passées comprises) sont retirées de la liste d'appel. Les appels faits restent dans l'historique.",
      "duplicate": "Dupliquer",
      "duplicateTitle": "Dupliquer la séance",
      "customTime": "Horaire libre…",
      "start": "Début",
      "end": "Fin",
      "timeError": "La fin doit être après le début.",
      "window": "Enseignée du {{from}} au {{to}} (plan d’études).",
      "blockedTitle": "Enseignant indisponible",
      "blocked": "L'enseignant a déjà cours en {{group}} ({{course}}) à ce moment. Une séance commune n'est possible qu'entre groupes du même niveau.",
      "jointSaved": "Séance commune enregistrée avec {{groups}} : un seul cours, un appel par groupe."
    },
    "errors": {
      "generic": "Impossible d'enregistrer. Réessayez.",
      "reference": "Une donnée sélectionnée n'existe plus. Rechargez la page.",
      "plan": "Validez le plan d'études de la filière avant de planifier l'emploi du temps.",
      "time": "Heure invalide (HH:MM).",
      "endBeforeStart": "La fin doit être après le début."
    },
    "legend": "Légende :",
    "absent": "ABSENT",
    "level": "Niveau",
    "allLevels": "Tous les niveaux",
    "prevDay": "Jour précédent",
    "nextDay": "Jour suivant",
    "overviewTitle": "Tous les groupes — {{date}}",
    "jointWith": "Séance commune avec {{groups}}",
    "history": "Historique des enseignants",
    "historySessions_one": "{{count}} séance",
    "historySessions_other": "{{count}} séances",
    "absence": {
      "badge": "Enseignant absent",
      "mark": "Enseignant absent",
      "clear": "Annuler l'absence",
      "marked": "Absence de l'enseignant enregistrée : le groupe est prévenu, l'appel est fermé.",
      "cleared": "Absence annulée : l'appel est de nouveau possible.",
      "rollCallDone": "L'appel de cette séance est déjà fait."
    },
    "tags": {
      "title": "Étiquettes",
      "hint": "Glissez une matière sur un créneau libre, un enseignant ou une salle sur une séance.",
      "courses": "Matières",
      "teachers": "Enseignants",
      "rooms": "Salles",
      "search": "Filtrer les étiquettes",
      "pickLevel": "Choisissez un niveau pour voir ses matières.",
      "noCourse": "Aucune matière en cours pour ce semestre.",
      "otherLevel": "Cette matière n'est pas enseignée en {{group}}.",
      "sameRow": "Une séance se déplace sur la ligne de son groupe."
    }
  },
  "announcements": {
    "title": "Annonces",
    "subtitle": "Publiées dans l'application étudiant, par public.",
    "new": "Nouvelle annonce",
    "publish": "Publier",
    "published": "Annonce publiée.",
    "failed": "Publication impossible. Réessayez.",
    "deleted": "Annonce supprimée.",
    "delete": "Supprimer « {{title}} »",
    "deleteTitle": "Supprimer cette annonce ?",
    "emptyTitle": "Aucune annonce",
    "emptyText": "Les annonces publiées apparaissent ici et dans l'application étudiant.",
    "fields": {
      "title": "Titre",
      "body": "Message",
      "kind": "Type",
      "audience": "Public"
    },
    "kinds": {
      "info": "Information",
      "event": "Événement",
      "warning": "Important",
      "room": "Salle"
    },
    "audience": {
      "all": "Tous les étudiants",
      "program": "Filière",
      "level": "Niveau",
      "group": "Groupe"
    }
  },
  "notifications": {
    "weekdays": {
      "1": "lundi",
      "2": "mardi",
      "3": "mercredi",
      "4": "jeudi",
      "5": "vendredi",
      "6": "samedi",
      "7": "dimanche"
    },
    "sessions": {
      "principale": "principale",
      "rattrapage": "de rattrapage"
    },
    "absence": {
      "recorded": {
        "title": "Absence enregistrée — {{course}}",
        "body": "Vous avez {{hours}} h pour déposer un justificatif."
      },
      "alert": {
        "title": "Absences — {{course}}",
        "body": "Taux d'absences non justifiées : {{pct}}."
      }
    },
    "timetable": {
      "room": {
        "title": "Changement de salle — {{course}}",
        "body": "Le {{day}} à {{time}}, la séance a lieu en {{room}}."
      },
      "conflict": {
        "title": "Conflit de salle",
        "body": "{{room}} · {{day}} {{time}} · {{groups}}"
      },
      "teacherAbsent": {
        "title": "Séance annulée — {{course}}",
        "body": "Enseignant absent le {{at}}."
      }
    },
    "justification": {
      "approved": {
        "title": "Justificatif accepté",
        "body": "Vos absences sont justifiées."
      },
      "rejected": {
        "title": "Justificatif refusé",
        "body": "Contactez la scolarité."
      }
    },
    "request": {
      "done": {
        "title": "{{kind}} : demande traitée",
        "body": "Le document est disponible auprès de la scolarité ou dans vos documents."
      },
      "rejected": {
        "title": "{{kind}} : demande refusée",
        "body": "Contactez la scolarité pour plus de détails."
      }
    },
    "deliberation": {
      "pvToValidate": {
        "title": "PV de délibération à valider",
        "body": "{{level}} · Semestre {{semester}} · session {{session}}"
      }
    },
    "title": "Pour vous",
    "empty": "Aucune notification.",
    "gradeReview": {
      "requested": {
        "title": "Demande de vérification de note",
        "body": "{{student}} · {{course}}"
      },
      "answered": {
        "title": "Réponse à votre demande de vérification",
        "body": "{{course}} : {{outcome}}"
      }
    },
    "internship": {
      "answers": {
        "accepted": "acceptée",
        "refused": "refusée",
        "assigned": "vous êtes désigné(e)"
      },
      "decision": {
        "title": "Sujet de stage : {{status}}",
        "body": "{{title}}"
      },
      "supervisionRequested": {
        "title": "Demande d'encadrement",
        "body": "{{title}}"
      },
      "supervisionAnswered": {
        "title": "Encadrement de stage",
        "body": "{{title}} : {{answer}}"
      },
      "defensePublished": {
        "title": "Date de soutenance publiée",
        "body": "Votre soutenance a lieu le {{at}}."
      }
    }
  },
  "account": {
    "menu": "Mon compte",
    "title": "Mon compte",
    "passwordTitle": "Mot de passe",
    "passwordHint": "Au moins {{min}} caractères. Vos autres sessions (autres appareils) seront fermées.",
    "current": "Mot de passe actuel",
    "new": "Nouveau mot de passe",
    "confirm": "Confirmer le nouveau mot de passe",
    "submit": "Changer le mot de passe",
    "passwordChanged": "Mot de passe modifié. Vos autres sessions ont été fermées.",
    "errors": {
      "wrongPassword": "Mot de passe actuel incorrect.",
      "generic": "Modification impossible. Réessayez dans un instant."
    }
  },
  "audit": {
    "actions": {
      "absence_justify": "Absences justifiées",
      "absence_justify_reject": "Justificatif refusé",
      "absence_notify": "Alerte d'absences envoyée",
      "announcement_create": "Annonce publiée",
      "announcement_delete": "Annonce supprimée",
      "application_convert": "Candidature convertie en inscription",
      "application_piece_upload": "Pièce de candidature déposée",
      "application_status": "Statut de candidature modifié",
      "application_submit": "Candidature déposée",
      "attendance_update": "Appel modifié",
      "auth_password_change": "Mot de passe changé",
      "auth_password_reset": "Mot de passe réinitialisé",
      "auth_refresh_reuse_detected": "Session suspecte fermée",
      "curriculum_delete": "Offre de formation supprimée",
      "curriculum_new_version": "Nouvelle version d'offre de formation",
      "curriculum_publish": "Offre de formation publiée",
      "document_issue": "Document émis",
      "document_revoke": "Document révoqué",
      "document_send": "Document envoyé par e-mail",
      "document_request_done": "Demande de document traitée",
      "document_request_rejected": "Demande de document refusée",
      "enrollment_create": "Inscription validée",
      "enrollment_group_change": "Changement de groupe",
      "enrollment_update": "Inscription modifiée",
      "fee_schedule_apply": "Barème appliqué aux échéanciers",
      "fee_schedule_save": "Barème modifié",
      "grade_correction_request": "Correction de note demandée",
      "grade_update": "Note modifiée après enregistrement",
      "grades_import": "Notes importées (Excel)",
      "grades_lock": "Feuille de notes transmise",
      "grades_unlock": "Feuille de notes rouverte",
      "jury_decision": "Décision du jury modifiée",
      "jury_pv": "Procès-verbal généré",
      "jury_rattrapage_sheets": "Feuilles de rattrapage créées",
      "payment_cancel": "Paiement annulé",
      "payment_clear": "Paiement encaissé",
      "payment_create": "Paiement enregistré",
      "payment_reject": "Chèque rejeté",
      "permissions_update": "Droits modifiés",
      "platform_tenant_create": "Établissement créé",
      "program_create": "Filière créée",
      "room_create": "Salle créée",
      "room_update": "Salle modifiée",
      "student_create": "Dossier étudiant créé",
      "student_update": "Dossier étudiant modifié",
      "tenant_branding": "Identité visuelle modifiée",
      "tenant_logo": "Logo modifié",
      "tenant_update": "Réglages de l'établissement modifiés",
      "timetable_slot_delete": "Créneau supprimé",
      "timetable_slot_room": "Salle d'un créneau réaffectée",
      "year_activate": "Année universitaire ouverte",
      "year_archive": "Année universitaire archivée",
      "year_create": "Année universitaire créée",
      "year_delete": "Année universitaire supprimée",
      "year_update": "Année universitaire modifiée",
      "platform_tenant_suspend": "Établissement suspendu",
      "platform_tenant_activate": "Établissement réactivé",
      "platform_tenant_reinvite": "Invitation renvoyée à l'administrateur",
      "platform_admin_reset": "Mot de passe du super admin réinitialisé (serveur)",
      "platform_admin_create": "Super admin créé (serveur)",
      "teacher_create": "Fiche enseignant créée",
      "teacher_update": "Fiche enseignant modifiée",
      "teacher_export": "Liste des enseignants exportée (Excel)",
      "study_plan_period": "Période d'enseignement modifiée",
      "study_plan_validate": "Plan d'études validé"
    },
    "entities": {
      "student": "Étudiant",
      "grade_sheet": "Feuille de notes",
      "jury": "Jury",
      "application": "Candidature",
      "user": "Compte",
      "settings": "Réglages",
      "academic_year": "Année universitaire",
      "curriculum": "Offre de formation",
      "timetable_slot": "Emploi du temps",
      "announcement": "Annonce",
      "tenant": "Établissement",
      "attendance": "Présences",
      "class_session": "Séance",
      "fee_schedule": "Barème",
      "program": "Filière",
      "room": "Salle",
      "teacher": "Enseignant",
      "study_plan": "Plan d'études"
    },
    "title": "Journal d'audit",
    "subtitle": "Actions sensibles : qui, quoi, quand. Le détail reste sur chaque dossier.",
    "columns": {
      "at": "Date",
      "actor": "Par",
      "action": "Action",
      "record": "Concerne"
    },
    "search": "Personne, étudiant, matricule…",
    "since": "Depuis le",
    "empty": "Aucune action enregistrée",
    "emptyText": "Modifiez les filtres ou revenez après les premières actions sensibles."
  },
  "teachers": {
    "title": "Enseignants",
    "subtitle": "Fiche, RIB et affiliation. L'export Excel ne garde que les enseignants actifs qui ont une matière cette année.",
    "new": "Nouvel enseignant",
    "edit": "Modifier l'enseignant",
    "save": "Enregistrer",
    "export": "Exporter Excel",
    "empty": "Aucun enseignant",
    "created": "Enseignant créé. Il choisit son mot de passe via « Mot de passe oublié ».",
    "updated": "Fiche enseignant enregistrée.",
    "noSubject": "Aucune matière",
    "status": {
      "active": "Actif",
      "disabled": "Inactif",
      "invited": "Invité"
    },
    "affiliation": {
      "cnss": "CNSS",
      "cnrps": "CNRPS",
      "none": "Sans affiliation"
    },
    "fields": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "E-mail",
      "cin": "CIN",
      "rib": "RIB bancaire",
      "affiliation": "Affiliation sociale",
      "affiliationNumber": "Numéro d'affiliation",
      "fiscalId": "Matricule fiscal",
      "active": "Enseignant actif"
    },
    "hints": {
      "cin": "8 chiffres.",
      "rib": "20 chiffres, sans lettres."
    },
    "errors": {
      "required": "Champ obligatoire.",
      "email": "Veuillez saisir une adresse e-mail valide.",
      "cin": "Le CIN doit contenir 8 chiffres.",
      "rib": "Le RIB doit contenir exactement 20 chiffres.",
      "duplicateCin": "Ce numéro de CIN existe déjà dans le système.",
      "duplicateEmail": "Cette adresse e-mail est déjà utilisée.",
      "affiliationNumber": "Indiquez le numéro d'affiliation.",
      "affiliationNone": "Pas de numéro sans affiliation.",
      "generic": "Enregistrement impossible. Vérifiez la fiche."
    }
  },
  "studyPlan": {
    "title": "Plan d'études",
    "open": "Plan d'études",
    "subtitle": "Année {{year}} — validez le plan avant l'emploi du temps.",
    "next": "Continuer",
    "createProgram": "Nouvelle filière",
    "programCreated": "Filière créée.",
    "addClass": "Nouvelle classe",
    "groupCreated": "Classe créée.",
    "noClass": "Aucune classe cette année.",
    "addBasket": "Nouveau panier",
    "addSubject": "Nouvelle matière",
    "emptyBasket": "Panier vide.",
    "saved": "Enregistré.",
    "validated": "Plan d'études validé.",
    "ready": "Le plan est cohérent. Vous pouvez le valider.",
    "published": "Ce parcours est publié. Les paniers et les matières se modifient dans une nouvelle version.",
    "openBuilder": "Ouvrir le parcours",
    "filiereHint": "Créez la filière, puis associez-lui ses classes.",
    "classesHint": "Chaque niveau de la filière doit avoir au moins une classe pour l'année choisie.",
    "paniersHint": "Les paniers (UE) regroupent les matières d'un semestre. Ils sont communs aux classes du même niveau.",
    "subjectsHint": "Chaque matière a une pondération et un volume horaire.",
    "datesHint": "Attribuez une date de début et une date de fin à chaque matière, dans l'année universitaire.",
    "validationHint": "Vérifiez la filière, les classes, les paniers, les pondérations, les volumes et les dates avant de valider.",
    "validate": "Valider le plan d'études",
    "semester": "Semestre {{n}}",
    "subjectMeta": "Pondération {{weight}} · {{hours}} h",
    "status": {
      "missing": "Non préparé",
      "draft": "Brouillon",
      "validated": "Validé"
    },
    "steps": {
      "filiere": "Filière",
      "classes": "Classes",
      "paniers": "Paniers",
      "matieres": "Matières",
      "dates": "Dates",
      "validation": "Validation"
    },
    "fields": {
      "program": "Filière",
      "semester": "Semestre",
      "code": "Code du panier",
      "name": "Nom",
      "basket": "Panier",
      "weight": "Pondération",
      "hours": "Volume horaire",
      "cm": "CM",
      "td": "TD",
      "tp": "TP",
      "startsOn": "Début",
      "endsOn": "Fin"
    },
    "issues": {
      "no_curriculum": "Créez d'abord le parcours de la filière.",
      "credits": "Le semestre {{semester}} totalise {{credits}} crédits au lieu de {{target}}.",
      "empty_semester": "Le semestre {{semester}} n'a pas de panier.",
      "empty_unit": "Le panier {{unit}} (semestre {{semester}}) est vide.",
      "no_class": "Aucune classe pour {{level}} cette année.",
      "weight": "{{course}} n'a pas de pondération.",
      "hours": "{{course}} n'a pas de volume horaire.",
      "dates": "{{course}} n'a pas de dates de début et de fin.",
      "dates_order": "La fin de {{course}} doit être après le début.",
      "dates_outside": "Les dates de {{course}} sortent de l'année universitaire."
    },
    "errors": {
      "generic": "Opération impossible. Réessayez.",
      "invalid": "Le plan n'est pas encore cohérent.",
      "date": "Date invalide.",
      "order": "La fin doit être après le début."
    }
  },
  "calendar": {
    "title": "Calendrier académique",
    "subtitle": "Rentrée, vacances, examens, délibérations et soutenances · {{year}}",
    "new": "Nouvel événement",
    "editTitle": "Modifier l'événement",
    "show": "Événements affichés",
    "upcoming": "À venir",
    "wholeYear": "Toute l'année",
    "now": "En cours",
    "created": "Événement ajouté au calendrier.",
    "updated": "Événement modifié.",
    "deleted": "Événement supprimé.",
    "deleteTitle": "Supprimer cet événement ?",
    "edit": "Modifier « {{title}} »",
    "delete": "Supprimer « {{title}} »",
    "emptyTitle": "Le calendrier de l'année est vide",
    "noUpcomingTitle": "Aucune date à venir",
    "emptyText": "Les dates de l'année apparaîtront ici dès que l'administration les aura publiées.",
    "emptyTextEditor": "Ajoutez la rentrée, les vacances, les périodes d'examens et les délibérations : étudiants et enseignants les voient dans leur espace.",
    "fields": {
      "title": "Intitulé",
      "kind": "Type",
      "audience": "Visible par",
      "startsOn": "Du",
      "endsOn": "Au (facultatif)",
      "description": "Précisions (facultatif)"
    },
    "kinds": {
      "start": "Rentrée",
      "holiday": "Vacances / férié",
      "exams": "Examens",
      "deliberation": "Délibération",
      "defense": "Soutenances",
      "deadline": "Date limite",
      "event": "Événement"
    },
    "audience": {
      "all": "Tout le monde",
      "students": "Étudiants",
      "staff": "Personnel et enseignants"
    },
    "errors": {
      "title": "Saisissez un intitulé.",
      "date": "Date invalide.",
      "range": "La date de fin doit suivre la date de début."
    }
  },
  "gradeReviews": {
    "title": "Demandes de vérification",
    "subtitle": "Notes publiées que des étudiants demandent de vérifier",
    "backToSheets": "Fiches de notes",
    "filter": "Demandes affichées",
    "answered": "Traitées",
    "allSheets": "Toutes les fiches",
    "emptyPendingTitle": "Aucune demande en attente",
    "emptyTitle": "Aucune demande",
    "emptyText": "Les étudiants peuvent demander la vérification d'une note pendant quelques jours après la publication des résultats.",
    "about": "{{course}} · {{group}} · S{{semester}} · session {{session}}",
    "openSheet": "Ouvrir la fiche",
    "answer": "Répondre",
    "answerTitle": "Répondre à {{name}}",
    "outcome": "Résultat de la vérification",
    "correctHint": "Corrigez aussi la note : dans la grille si la fiche est en saisie, par une demande de correction si elle est transmise.",
    "response": "Réponse à l'étudiant",
    "send": "Envoyer la réponse",
    "sent": "Réponse envoyée à l'étudiant.",
    "pendingCount_one": "{{count}} demande en attente",
    "pendingCount_other": "{{count}} demandes en attente",
    "rowChip": "Vérif. demandée",
    "rowHint": "L'étudiant a demandé la vérification de cette note",
    "bannerTitle_one": "{{count}} demande de vérification en attente",
    "bannerTitle_other": "{{count}} demandes de vérification en attente",
    "bannerDraft": "Vérifiez la copie, corrigez la note dans la grille si besoin, puis répondez à l'étudiant.",
    "bannerLocked": "Vérifiez la copie ; si la note change, faites une demande de correction, puis répondez à l'étudiant.",
    "answerRequests": "Voir et répondre",
    "status": {
      "pending": "En attente",
      "maintained": "Note maintenue",
      "corrected": "Note corrigée"
    },
    "errors": {
      "message": "Expliquez votre demande en quelques mots (10 caractères au moins).",
      "response": "Écrivez une réponse."
    },
    "student": {
      "ask": "Demander une vérification",
      "title": "Demande de vérification",
      "intro": "Vous pensez que votre note en {{course}} est erronée (erreur de report, copie non comptée…) ? L'enseignant vérifie et vous répond ici.",
      "message": "Votre demande",
      "placeholder": "Exemple : ma note d'examen ne correspond pas à ma copie.",
      "helper": "Soyez précis : examen, DS ou TP concerné.",
      "send": "Envoyer la demande",
      "sent": "Demande envoyée. Vous serez notifié(e) de la réponse.",
      "window": "Vous pouvez demander la vérification d'une note jusqu'au {{date}}.",
      "status": {
        "pending": "Vérification demandée",
        "maintained": "Réponse : note maintenue",
        "corrected": "Réponse : note corrigée"
      },
      "errors": {
        "already_pending": "Une demande est déjà en cours pour cette note.",
        "window": "Le délai pour demander une vérification est dépassé.",
        "not_published": "Les résultats de cette session ne sont pas encore publiés.",
        "disabled": "L'établissement ne reçoit pas de demandes de vérification.",
        "failed": "La demande n'a pas pu être envoyée. Réessayez."
      }
    }
  },
  "internships": {
    "title": "Stages & PFE",
    "myTitle": "Mes encadrements",
    "subtitle": "Sujets, encadrement, dépôts et soutenances de l'année",
    "new": "Nouveau stage",
    "newHint": "Un stage créé par la scolarité est validé d'office : la convention est émise et l'encadrant désigné.",
    "create": "Créer le stage",
    "created": "Stage {{code}} créé.",
    "editTitle": "Modifier le stage",
    "saved": "Stage enregistré.",
    "notFound": "Stage introuvable",
    "pfe": "PFE",
    "search": "Sujet, entreprise, étudiant ou matricule",
    "allTypes": "Toutes les natures",
    "allStatuses": "Tous les états",
    "roleFilter": "Stages affichés",
    "roles": {
      "supervisor": "J'encadre",
      "requests": "Demandes d'encadrement",
      "jury": "Mes jurys"
    },
    "emptyTitle": "Aucun stage cette année",
    "emptyText": "Les étudiants déclarent leurs stages depuis leur espace ; la scolarité peut aussi en créer.",
    "emptyRole": {
      "supervisor": "Vous n'encadrez aucun stage",
      "requests": "Aucune demande d'encadrement",
      "jury": "Aucun jury pour le moment"
    },
    "emptyTeacherText": "Les étudiants peuvent vous proposer comme encadrant ; vous recevez alors une notification.",
    "tabs": {
      "list": "Stages",
      "sessions": "Soutenances",
      "types": "Natures"
    },
    "columns": {
      "code": "Référence",
      "title": "Sujet",
      "students": "Étudiants",
      "supervisor": "Encadrant",
      "documents": "Dépôts",
      "defense": "Soutenance",
      "status": "État"
    },
    "status": {
      "proposed": "Proposé",
      "to_revise": "À réviser",
      "approved": "Validé",
      "refused": "Refusé"
    },
    "supervision": {
      "none": "Aucun",
      "pending": "En attente",
      "accepted": "Accepté",
      "refused": "Refusé"
    },
    "documents": {
      "report": "Rapport",
      "certificate": "Attestation de stage",
      "plagiarism": "Rapport anti-plagiat",
      "logbook": "Journal de stage",
      "company_evaluation": "Évaluation de l'entreprise"
    },
    "sections": {
      "subject": "Sujet",
      "company": "Organisme d'accueil",
      "students": "Étudiants",
      "supervision": "Encadrement académique",
      "deposits": "Dépôts",
      "defense": "Soutenance"
    },
    "fields": {
      "type": "Nature",
      "title": "Intitulé du sujet",
      "description": "Objectifs et travail demandé",
      "startsOn": "Début",
      "endsOn": "Fin",
      "period": "Période",
      "companyName": "Entreprise ou organisme",
      "companyCity": "Ville",
      "companyAddress": "Adresse",
      "companySupervisorName": "Encadrant professionnel",
      "companySupervisorEmail": "E-mail de l'encadrant",
      "companySupervisorPhone": "Téléphone de l'encadrant",
      "contact": "Contact",
      "supervisor": "Encadrant académique",
      "supervisorHint": "L'enseignant reçoit une demande d'encadrement à accepter.",
      "students_one": "Étudiant",
      "students_other": "Étudiants (jusqu'à {{count}})",
      "studentsMax_one": "Un seul étudiant pour cette nature",
      "studentsMax_other": "{{count}} étudiants au plus",
      "studentsHint": "Tapez au moins 2 lettres du nom ou du matricule",
      "noStudent": "Aucun étudiant trouvé"
    },
    "noSupervisor": "Pas encore d'encadrant",
    "noDescription": "Aucune description.",
    "assignSupervisor": "Désigner l'encadrant",
    "changeSupervisor": "Changer d'encadrant",
    "supervisorSaved": "Encadrant désigné.",
    "supervisionRequest": "Un étudiant vous propose d'encadrer ce stage.",
    "acceptSupervision": "Accepter l'encadrement",
    "refuseSupervision": "Refuser",
    "supervisionAccepted": "Encadrement accepté : l'étudiant est prévenu.",
    "supervisionRefused": "Encadrement refusé : l'étudiant est prévenu.",
    "decide": "Décision sur le sujet",
    "decision": "Décision",
    "confirmDecision": "Enregistrer la décision",
    "approveHint": "La convention de stage est émise à la validation ; chaque étudiant la retrouve dans ses documents.",
    "reason": "Commentaire (facultatif)",
    "reasonRequired": "Motif (communiqué à l'étudiant)",
    "decided": {
      "approved": "Sujet validé : la convention est émise.",
      "to_revise": "Sujet renvoyé à l'étudiant pour révision.",
      "refused": "Sujet refusé."
    },
    "issueConvention": "Émettre la convention",
    "conventionIssued": "Convention émise.",
    "depositAfterApproval": "Les dépôts s'ouvrent une fois le sujet validé.",
    "depositClosed": "Les dépôts sont fermés (hors de la période de dépôt).",
    "notDeposited": "Pas encore déposé",
    "deposit": "Déposer",
    "replace": "Remplacer",
    "view": "Voir",
    "deposited": "Document déposé.",
    "noDefense": "Soutenance pas encore planifiée.",
    "grade": "Note",
    "gradeSaved": "Note enregistrée.",
    "jury": {
      "president": "Président du jury",
      "reviewer": "Rapporteur",
      "supervisor": "Encadrant",
      "guest": "Invité",
      "line": "Président : {{president}} · Rapporteur : {{reviewer}} · Encadrant : {{supervisor}}",
      "supervisorHint": "L'encadrant académique siège de droit ; il ne peut être ni président ni rapporteur."
    },
    "clashes": {
      "room": "Salle déjà occupée par « {{title}} » ({{time}})",
      "president": "Le président siège déjà à « {{title}} » ({{time}})",
      "reviewer": "Le rapporteur siège déjà à « {{title}} » ({{time}})",
      "supervisor": "L'encadrant est déjà pris par « {{title}} » ({{time}})",
      "student": "Un étudiant soutient déjà « {{title}} » ({{time}})"
    },
    "sessions": {
      "intro": "Une session fixe la période des soutenances et, avant elle, la période de dépôt des rapports.",
      "new": "Nouvelle session",
      "editTitle": "Modifier la session",
      "created": "Session créée.",
      "updated": "Session modifiée.",
      "allTypes": "Toutes les natures",
      "depositUntil": "dépôt jusqu'au {{date}}",
      "counts": "{{scheduled}} planifiées · {{published}} publiées",
      "emptyTitle": "Aucune session de soutenance",
      "emptyText": "Créez une session pour planifier les soutenances et ouvrir les dépôts.",
      "fields": {
        "title": "Intitulé",
        "startsOn": "Soutenances du",
        "endsOn": "au",
        "depositFrom": "Dépôt à partir du",
        "depositUntil": "Dépôt jusqu'au",
        "date": "Date",
        "time": "Heure",
        "room": "Salle"
      },
      "depositHint": "Sans période de dépôt, les étudiants déposent dès la validation de leur sujet.",
      "publish": "Publier les soutenances",
      "unpublish": "Retirer la publication",
      "publishedToast": "Soutenances publiées : les étudiants sont prévenus.",
      "unpublishedToast": "Publication retirée.",
      "notPublished": "Les soutenances ne sont pas encore publiées : les étudiants ne voient ni la date ni le jury.",
      "published": "Publiée",
      "draft": "Non publiée",
      "scheduled_one": "{{count}} soutenance planifiée",
      "scheduled_other": "{{count}} soutenances planifiées",
      "toSchedule_one": "{{count}} stage à planifier",
      "toSchedule_other": "{{count}} stages à planifier",
      "noneScheduled": "Aucune soutenance planifiée",
      "noneScheduledText": "Planifiez les stages validés listés ci-dessous.",
      "noCandidate": "Aucun stage validé en attente de soutenance pour cette session.",
      "ready": "Dossier complet",
      "missing": "Manque : {{list}}",
      "schedule": "Planifier",
      "reschedule": "Modifier la soutenance",
      "scheduledToast": "Soutenance planifiée.",
      "warningTitle": "À vérifier avant de planifier",
      "force": "Planifier quand même",
      "editDefense": "Modifier la soutenance « {{title}} »",
      "deleteDefense": "Supprimer la soutenance « {{title}} »",
      "deleteDefenseTitle": "Supprimer cette soutenance ?"
    },
    "types": {
      "intro": "Chaque nature (stage d'été, PFE…) fixe les niveaux concernés, la taille des équipes, les documents à déposer et la soutenance.",
      "new": "Nouvelle nature",
      "editTitle": "Modifier la nature",
      "created": "Nature créée.",
      "updated": "Nature modifiée.",
      "deleted": "Nature supprimée.",
      "deleteTitle": "Supprimer cette nature ?",
      "edit": "Modifier « {{name}} »",
      "delete": "Supprimer « {{name}} »",
      "duplicate": "Une nature porte déjà ce nom.",
      "usedHint_one": "{{count}} stage l'utilise : désactivez-la plutôt",
      "usedHint_other": "{{count}} stages l'utilisent : désactivez-la plutôt",
      "inactive": "Désactivée",
      "allLevels": "Tous les niveaux",
      "weeks_one": "{{count}} semaine",
      "weeks_other": "{{count}} semaines",
      "team_one": "Individuel",
      "team_other": "Équipe de {{count}} au plus",
      "defense_one": "Soutenance de {{count}} min",
      "defense_other": "Soutenance de {{count}} min",
      "noDefense": "Sans soutenance",
      "declarable": "déclaré par l'étudiant",
      "byOffice": "créé par la scolarité",
      "emptyTitle": "Aucune nature de stage",
      "emptyText": "Créez au moins une nature (par exemple « Stage d'été » et « PFE ») pour que les stages puissent être déclarés.",
      "fields": {
        "name": "Nom",
        "levels": "Niveaux concernés",
        "levelsHint": "Aucun niveau sélectionné : tous les niveaux.",
        "weeks": "Durée (semaines)",
        "team": "Étudiants par stage",
        "minutes": "Durée de soutenance (min)",
        "isPfe": "Projet de fin d'études",
        "declarable": "Les étudiants déclarent eux-mêmes leur stage",
        "companySupervisor": "Encadrant professionnel obligatoire (nom et e-mail)",
        "hasDefense": "Soutenance devant un jury",
        "active": "Active (proposée pour les nouveaux stages)",
        "required": "Documents à déposer avant la soutenance"
      }
    },
    "errors": {
      "invalid": "Vérifiez les champs du formulaire.",
      "type": "Choisissez la nature du stage.",
      "title": "Saisissez un intitulé (5 caractères au moins).",
      "name": "Saisissez un nom.",
      "company": "Saisissez l'entreprise ou l'organisme d'accueil.",
      "date": "Date invalide.",
      "range": "La date de fin doit suivre la date de début.",
      "phone": "Téléphone invalide.",
      "email": "E-mail invalide.",
      "reason": "Indiquez le motif.",
      "students": "Choisissez au moins un étudiant.",
      "team_size": "Trop d'étudiants pour cette nature.",
      "company_supervisor": "Le nom et l'e-mail de l'encadrant professionnel sont obligatoires pour cette nature.",
      "already": "Un stage de cette nature existe déjà pour cette année.",
      "level": "Cette nature ne concerne pas ce niveau.",
      "not_enrolled": "Étudiant non inscrit cette année.",
      "not_teacher": "Choisissez un enseignant de l'établissement.",
      "not_declarable": "Ce stage est enregistré par la scolarité.",
      "inactive": "Cette nature n'est plus proposée.",
      "decided": "Le sujet est déjà validé : contactez la scolarité pour le modifier.",
      "graded": "Le stage est déjà noté.",
      "supervision": "Une demande d'encadrement est déjà en cours.",
      "not_approved": "Le sujet n'est pas encore validé.",
      "closed": "La période de dépôt est fermée.",
      "too_large": "Fichier trop volumineux (10 Mo au plus).",
      "type_file": "Format non accepté : PDF, JPEG ou PNG.",
      "empty": "Aucun fichier envoyé.",
      "upload": "Le dépôt a échoué. Réessayez.",
      "jury": "Le président, le rapporteur et l'encadrant doivent être trois personnes différentes.",
      "outside_session": "La date est hors de la période de la session.",
      "session": "Ce stage n'entre pas dans cette session.",
      "already_scheduled": "Ce stage a déjà une soutenance.",
      "president": "Choisissez le président du jury.",
      "reviewer": "Choisissez le rapporteur."
    }
  }
}
